import React, { useEffect, useState } from "react";
import BaseFormComponent from "./form_fields/BaseFormComponent";
import Select from 'react-select';
import { toast } from "react-toastify";
import { useDropdownStore } from "./store/useDropdownStore";
import { Formik, Form, ErrorMessage, Field, FieldArray } from "formik";
import FilePreview from "./FilePreview";
import { useVehicleStore } from "./store/useVehicleStore";
import getValidationSchema from "./getValidationSchema";
import { waveform } from "ldrs";
import { handleUuid } from "../../../utils/ValidationsHelper";
import { getWritePermission } from "./utils/helpers";
import { API_BASE_URL1 } from "../../Services/baseApiUrl";
import axiosInstance from "../../../Hooks/axoisInstance";
import RouteMastersStore from "../RouteMaster/store/useRouteMasterStore";

const AddVehicleForm = ({
  handleSearch,
  editVehicleData,
  setEditVehicleData,
  handleClose,
}) => {
  const {
    fuelTypes,
    collectionTypes,
    vehicleTypes,
    ownerTypes,
    vehicleCapacities,
    zones,
    circles,
    wards,
    drivers,
    primaryDeploymentIncharges,
    secondaryDeploymentIncharges,
    transferStations,
    loading,
    vehicleStatus,
    fileInputs,
    filePreviews,
    resetFileInputs,
    fetchVehicleTypes,
    fetchOwnerTypes,
    fetchVehicleCapacities,
    fetchVehicleStatus,
    fetchFuelTypes,
    fetchCollectionTypes,
    fetchZones,
    fetchCircles,
    fetchWards,
    fetchDrivers,
    fetchPrimaryDeploymentIncharges,
    fetchSecondaryDeploymentIncharges,
    fetchTransferStations,
    handleFileChange,
    updateFilePreview,
    fetchAllVehicleCategories,
    vehicleCategoryData,
fetchAllRouteStartAndEndPoints,
routestartAndEndPointsData,
  } = useDropdownStore();
  const canWrite = getWritePermission();
  const { fetchRouteMasters, routeMasterData } = RouteMastersStore()
  const {
    saveVehicleDetails,
  } = useVehicleStore();


  const [collectionPoints, setCollectionPoints] = useState([]);
  const [tripRows, setTripRows] = useState([]);
  const [collectionTypeId, setCollectionTypeId] = useState("");
  const [isSubmit, setIsSubmit] = useState(false);
  const [routePointsByTrip, setRoutePointsByTrip] = useState({});
  waveform.register();

  const getToken = () => localStorage.getItem('token');

  const fetchCollectionPoints = async () => {
    try {
      const collectionPointsData = await axiosInstance.get(
        `${API_BASE_URL1}Routes/GetAllCollectionPoints`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`,
          },
        }
      );
      setCollectionPoints(collectionPointsData.data.filter((cp) => cp.isActive));
    } catch (error) {
      console.error('Error fetching collection points:', error);
      toast.error('Failed to fetch collection points');
    }
  };

  useEffect(() => {
    fetchCollectionPoints();
    fetchFuelTypes();
    fetchCollectionTypes();
    fetchVehicleStatus();
    fetchOwnerTypes();
    fetchZones();
    fetchDrivers();
    fetchPrimaryDeploymentIncharges();
    fetchSecondaryDeploymentIncharges();
    fetchTransferStations();
    fetchAllVehicleCategories();
    fetchRouteMasters()
    if (editVehicleData) {
      fetchVehicleTypes(editVehicleData?.collectionTypeId);
      fetchVehicleCapacities(editVehicleData?.vehicleTypeId);
      fetchAllRouteStartAndEndPoints();
      fetchCircles(editVehicleData?.zoneId);
      fetchWards(editVehicleData?.circleId);
      fetchDrivers(editVehicleData?.collectionTypeId);
      setCollectionTypeId(editVehicleData?.collectionTypeId || "");
      updateFilePreview(
        editVehicleData?.vehicleImageUrl ?? null,
        editVehicleData?.rcimageUrl ?? null,
        editVehicleData?.pcimageUrl ?? null
      );
     
      // Always ensure at least one trip row is present

    } 
  }, [editVehicleData]);

  const initialVehicleDetails = {
    vehicleNumber: editVehicleData?.vehicleNumber || "",
    chassisNumber: editVehicleData?.chassisNumber || "",
    fuelTypeId: editVehicleData?.fuelTypeId || "",
    collectionTypeId: editVehicleData?.collectionTypeId || "",
    vehicleTypeId: editVehicleData?.vehicleTypeId || "",
    vehicleCapacityId: editVehicleData?.vehicleCapacityId || "",
    vehicleStatusId: editVehicleData?.vehicleStatusId || "",
    ownerTypeId: editVehicleData?.ownerTypeId || "",
    vehicleUuid: editVehicleData?.vehicleUuid || "",
    zoneId: editVehicleData?.zoneId || "",
    circleId: editVehicleData?.circleId || "",
    driverId: editVehicleData?.driverId || "",
    RFID: editVehicleData?.rfid || "",
    primaryDeploymentInchargeId: editVehicleData?.primaryDeploymentInchargeId || "",
    secondaryDeploymentInchargeId: editVehicleData?.secondaryDeploymentInchargeId || "",
    transferStationId: editVehicleData?.transferStationId || "",
    vehicleImageUrl: null,
    rcimageUrl: null,
    pcimageUrl: null,
    vehicleBrandName: editVehicleData?.vehicleBrandName || "",
    contractorName: editVehicleData?.contractorName || "",
    vehicleCategoryId: editVehicleData?.vehicleCategoryId || "",
    remark: editVehicleData?.remark || "",
    isActive: editVehicleData?.isActive ?? true,
    fuelTypeName: editVehicleData?.fuelTypeName || "",
    collectionTypeName: editVehicleData?.collectionTypeName || "",
    ownerTypeName: editVehicleData?.ownerTypeName || "",
    transferStationName: editVehicleData?.transferStationName || "",
    vehicleTypeName: editVehicleData?.vehicleTypeName || "",
    vehicleCapacityName: editVehicleData?.vehicleCapacityName || "",
    vehicleStatusName: editVehicleData?.vehicleStatusName || "",
    DriverNumber: editVehicleData?.driverNumber || "",
    DriverName: editVehicleData?.driverName || "",
    PrimaryDeploymentInchargeName: editVehicleData?.primaryDeploymentInchargeName || "",
    PrimaryDeploymentInchargeNumber: editVehicleData?.primaryDeploymentInchargeNumber || "",
    SecondaryDeploymentInchargeNumber: editVehicleData?.SecondaryDeploymentInchargeNumber || "",
    SecondaryDeploymentInchargeName: editVehicleData?.secondaryDeploymentInchargeName || "",
  
    ...(editVehicleData?.vehicleId && { vehicleId: editVehicleData.vehicleId }),
  };
  
  const getAvailableCollectionPoints = (tripIndex, column) => {
    const points = routePointsByTrip[tripIndex] || collectionPoints;
    const currentRow = tripRows[tripIndex];

    let availablePoints = points;
    if (column === 'startingCollectionPointId' && currentRow?.endingCollectionPointId) {
      availablePoints = availablePoints.filter(
        ({ collectionPointId }) => collectionPointId !== Number(currentRow.endingCollectionPointId)
      );
    }
    if (column === 'endingCollectionPointId' && currentRow?.startingCollectionPointId) {
      availablePoints = availablePoints.filter(
        ({ collectionPointId }) => collectionPointId !== Number(currentRow.startingCollectionPointId)
      );
    }

    return availablePoints.map(({ collectionPointId, collectionPointCode }) => ({
      value: collectionPointId.toString(),
      label: collectionPointCode
    }));
  };


  const handleShiftChange = (rowId, shift) => {
    setTripRows(
      tripRows.map((row) => {
        if (row.id === rowId) {
          const updatedShifts = row.shifts.includes(shift)
            ? row.shifts.filter((s) => s !== shift)
            : [...row.shifts, shift];
          return { ...row, shifts: updatedShifts };
        }
        return row;
      })
    );
  };

  const handleRouteCodeChange = async (tripIndex, routeCode, setFieldValue) => {
    setTripRows(
      tripRows.map((row, idx) =>
        idx === tripIndex ? { ...row, routeCode } : row
      )
    );

    if (routeCode) {
      try {
        await fetchAllRouteStartAndEndPoints(routeCode);
        setRoutePointsByTrip((prev) => ({
          ...prev,
          [tripIndex]: routestartAndEndPointsData,
        }));

        // Clear existing start/end points when route code changes
        setFieldValue(`mappings.${tripIndex}.startingCollectionPointId`, '');
        setFieldValue(`mappings.${tripIndex}.endingCollectionPointId`, '');
      } catch (error) {
        console.error('Error fetching route points:', error);
        toast.error('Failed to fetch route points');
      }
    } else {
      setRoutePointsByTrip((prev) => {
        const newPoints = { ...prev };
        delete newPoints[tripIndex];
        return newPoints;
      });
      setFieldValue(`mappings.${tripIndex}.startingCollectionPointId`, '');
      setFieldValue(`mappings.${tripIndex}.endingCollectionPointId`, '');
    }
  };


  const handleSubmit = async (values, { resetForm, setErrors }) => {
    setIsSubmit(true);

  
    const formattedValues = {
      ...values,
      wardId: values.wardId ? values.wardId : undefined,
      PrimaryDeploymentInchargeName:
        values.collectionTypeId === "2" ? "" : values.PrimaryDeploymentInchargeName,
      PrimaryDeploymentInchargeNumber:
        values.collectionTypeId === "2" ? "" : values.PrimaryDeploymentInchargeNumber,
      SecondaryDeploymentInchargeNumber:
        values.collectionTypeId === "1" ? "" : values.SecondaryDeploymentInchargeNumber,
      SecondaryDeploymentInchargeName:
        values.collectionTypeId === "1" ? "" : values.SecondaryDeploymentInchargeName,
   
    };

    try {
      await saveVehicleDetails(formattedValues, editVehicleData);
      handleSearch();
      toast.success(
        editVehicleData
          ? "Vehicle updated successfully"
          : "New Vehicle added successfully"
      );
      setEditVehicleData(null);
      handleClose();
      resetFileInputs();
      setIsSubmit(false);
      resetForm();
    } catch (xhr) {
      console.error("Submission error:", xhr);
      if (xhr?.response?.data?.errors && typeof xhr.response.data.errors === "object") {
        const formErrors = {};
        Object.keys(xhr.response.data.errors).forEach((key) => {
          if (
            Array.isArray(xhr.response.data.errors[key]) &&
            xhr.response.data.errors[key].length > 0
          ) {
            formErrors[key] = xhr.response.data.errors[key][0];
            toast.error(`${key}: ${xhr.response.data.errors[key][0]}`);
          }
        });
        setErrors(formErrors);
      } else {
        toast.error(xhr.response?.data || "An error occurred while saving the vehicle.");
      }
      setIsSubmit(false);
    }
  };

  const handleSpecialCharacters = (e) => {
    const value = e.target.value;
    const sanitizedValue = value
      .replace(/[^a-zA-Z0-9\s]/g, "")
      .replace(/^\s+/, "")
      .replace(/\s{2,}/g, " ");
    e.target.value = sanitizedValue;
  };

  return (
    <div>
      <Formik
        initialValues={{
          ...initialVehicleDetails,
     
        }}
        validationSchema={getValidationSchema(collectionTypeId, editVehicleData)}
        onSubmit={handleSubmit}
        validateOnChange={true}
        validateOnBlur={true}
        enableReinitialize={true}
      >
        {({
          values,
          setFieldValue,
          setFieldError,
          resetForm,
          setFieldTouched,
          setErrors,
          setTouched,
        }) => (
          <Form>
            <div className="row">
              <BaseFormComponent
                label="Vehicle Number"
                name="vehicleNumber"
                type="text"
                placeholder="Enter Vehicle Registration Number"
                required
              />
              <BaseFormComponent
                label="Vehicle Chassis Number"
                name="chassisNumber"
                type="text"
                max="30"
                handleSpecialCharacters={handleSpecialCharacters}
                placeholder="Enter Vehicle Chassis Number"
              />
              <div className="col-md-4">
                <div className="form-group">
                  <label className="form-label">
                    Fuel Type
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <Field
                    as="select"
                    name="fuelTypeId"
                    className="form-select"
                    onChange={(e) => {
                      const selectedFuelTypeId = e.target.value;
                      setFieldValue("fuelTypeId", selectedFuelTypeId);
                      setFieldTouched("fuelTypeId", false);
                      setFieldError("fuelTypeId", "");
                      const selectedFuelType = fuelTypes.find(
                        (fuelType) =>
                          fuelType.fuelTypeId === Number(selectedFuelTypeId)
                      );
                      if (selectedFuelType) {
                        setFieldValue(
                          "fuelTypeName",
                          selectedFuelType.fuelTypeName
                        );
                      }
                    }}
                  >
                    <option value="">Select</option>
                    {fuelTypes.map((fuelType) => (
                      <option
                        key={fuelType.fuelTypeId}
                        value={fuelType.fuelTypeId}
                      >
                        {fuelType.fuelTypeName}
                      </option>
                    ))}
                  </Field>
                  <ErrorMessage
                    className="form-text text-danger"
                    name="fuelTypeId"
                    component="div"
                  />
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label className="form-label">
                    Collection Type
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <Field
                    as="select"
                    name="collectionTypeId"
                    className="form-select"
                    onChange={(e) => {
                      const selectedValue = e.target.value;
                      const previousValue = values.collectionTypeId;
                      setFieldValue("collectionTypeId", selectedValue);
                      setFieldTouched("collectionTypeId", false);
                      setFieldError("collectionTypeId", "");
                      if (previousValue === "1" && selectedValue !== "1") {
                        setFieldValue("driverId", "");
                        setFieldTouched("driverId", false);
                        setFieldError("driverId", "");
                      }
                      if (selectedValue) {
                        setCollectionTypeId(selectedValue);
                        fetchVehicleTypes(selectedValue);
                        fetchDrivers(selectedValue);
                        if (selectedValue === "1") {
                          fetchPrimaryDeploymentIncharges();
                        } else if (selectedValue === "2") {
                          fetchSecondaryDeploymentIncharges();
                        }
                      }
                      const selectedCollectionType = collectionTypes.find(
                        (collectionType) =>
                          collectionType.collectionTypeId === Number(selectedValue)
                      );
                      if (selectedCollectionType) {
                        setFieldValue("collectionTypeName", selectedCollectionType.collectionTypeName);
                      }
                    }}
                  >
                    <option value="">Select</option>
                    {collectionTypes.map((collectionType) => (
                      <option
                        key={collectionType.collectionTypeId}
                        value={collectionType.collectionTypeId}
                      >
                        {collectionType.collectionTypeName}
                      </option>
                    ))}
                  </Field>
                  <ErrorMessage
                    className="form-text text-danger"
                    name="collectionTypeId"
                    component="div"
                  />
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label className="form-label">
                    Vehicle Type
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <Field
                    as="select"
                    name="vehicleTypeId"
                    className="form-select"
                    onChange={(e) => {
                      setFieldValue("vehicleTypeId", e.target.value);
                      setFieldTouched("vehicleTypeId", false);
                      setFieldError("vehicleTypeId", "");
                      if (e.target.value) {
                        fetchVehicleCapacities(e.target.value);
                      }
                      const selectedVehicleTypeId = e.target.value;
                      const selectedVehicleType = vehicleTypes.find(
                        (vehicleType) =>
                          vehicleType.vehicleTypeId ===
                          Number(selectedVehicleTypeId)
                      );
                      if (selectedVehicleType) {
                        setFieldValue(
                          "vehicleTypeName",
                          selectedVehicleType.vehicleTypeName
                        );
                      }
                    }}
                  >
                    <option value="">Select</option>
                    {vehicleTypes
                      .filter((vehicleType) => vehicleType.isActive)
                      .map((vehicleType) => (
                        <option
                          key={vehicleType.vehicleTypeId}
                          value={vehicleType.vehicleTypeId}
                        >
                          {vehicleType.vehicleTypeName}
                        </option>
                      ))}
                  </Field>
                  <ErrorMessage
                    className="form-text text-danger"
                    name="vehicleTypeId"
                    component="div"
                  />
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label className="form-label">
                    Vehicle Capacity
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <Field
                    as="select"
                    name="vehicleCapacityId"
                    className="form-select"
                    onChange={(e) => {
                      const selectedVehicleCapacityId = e.target.value;
                      setFieldValue("vehicleCapacityId", e.target.value);
                      setFieldTouched("vehicleCapacityId", false);
                      setFieldError("vehicleCapacityId", "");
                      const selectedVehicleCapacity = vehicleCapacities.find(
                        (vehicleCapacity) =>
                          vehicleCapacity.vehicleCapacityId ===
                          Number(selectedVehicleCapacityId)
                      );
                      if (selectedVehicleCapacity) {
                        setFieldValue(
                          "vehicleCapacityName",
                          selectedVehicleCapacity.vehicleCapacityName
                        );
                      }
                    }}
                  >
                    <option value="">Select</option>
                    {vehicleCapacities
                      .filter((vehicleCapacity) => vehicleCapacity.isActive)
                      .map((vehicleCapacity) => (
                        <option
                          key={vehicleCapacity.vehicleCapacityId}
                          value={vehicleCapacity.vehicleCapacityId}
                        >
                          {vehicleCapacity.vehicleCapacityName}
                        </option>
                      ))}
                  </Field>
                  <ErrorMessage
                    className="form-text text-danger"
                    name="vehicleCapacityId"
                    component="div"
                  />
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label className="form-label">
                    Vehicle Status
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <Field
                    as="select"
                    name="vehicleStatusId"
                    className="form-select"
                    onChange={(e) => {
                      const selectedVehicleStatusId = e.target.value;
                      setFieldValue("vehicleStatusId", e.target.value);
                      setFieldTouched("vehicleStatusId", false);
                      setFieldError("vehicleStatusId", "");
                      const selectedVehicleStatus = vehicleStatus.find(
                        (status) =>
                          status.vehicleStatusId ===
                          Number(selectedVehicleStatusId)
                      );
                      Number(selectedVehicleStatusId) === 2
                        ? setFieldValue("isActive", false)
                        : setFieldValue("isActive", true);
                      setFieldValue(
                        "vehicleStatusName",
                        selectedVehicleStatus?.vehicleStatusName
                      );
                    }}
                  >
                    <option value="">Select</option>
                    {vehicleStatus.map((status) => (
                      <option
                        key={status.vehicleStatusId}
                        value={status.vehicleStatusId}
                      >
                        {status.vehicleStatusName}
                      </option>
                    ))}
                  </Field>
                  <ErrorMessage
                    className="form-text text-danger"
                    name="vehicleStatusId"
                    component="div"
                  />
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label className="form-label">
                    Owner Type
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <Field
                    as="select"
                    name="ownerTypeId"
                    className="form-select"
                    onChange={(e) => {
                      const selectedOwnerTypeId = e.target.value;
                      setFieldValue("ownerTypeId", e.target.value);
                      setFieldTouched("ownerTypeId", false);
                      setFieldError("ownerTypeId", "");
                      const selectedOwnerType = ownerTypes.find(
                        (ownerType) =>
                          ownerType.ownerTypeId === Number(selectedOwnerTypeId)
                      );
                      if (selectedOwnerType) {
                        setFieldValue(
                          "ownerTypeName",
                          selectedOwnerType.ownerTypeName
                        );
                      }
                    }}
                  >
                    <option value="">Select</option>
                    {ownerTypes
                      .filter((owner) => owner.isActive)
                      .map((owner) => (
                        <option key={owner.ownerTypeId} value={owner.ownerTypeId}>
                          {owner.ownerTypeName}
                        </option>
                      ))}
                  </Field>
                  <ErrorMessage
                    className="form-text text-danger"
                    name="ownerTypeId"
                    component="div"
                  />
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label className="form-label">
                    Vehicle UID
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <Field
                    type="text"
                    id="vehicleUuid"
                    maxLength="20"
                    name="vehicleUuid"
                    onInput={handleUuid}
                    className="form-control"
                    placeholder="Enter Vehicle UID"
                  />
                  <ErrorMessage
                    className="form-text text-danger"
                    name="vehicleUuid"
                    component="div"
                  />
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label className="form-label">
                    Zone
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <Field
                    as="select"
                    name="zoneId"
                    className="form-select"
                    onChange={(e) => {
                      setFieldValue("zoneId", e.target.value);
                      setFieldValue("circleId", "");
                      setFieldValue("wardId", "");
                      setFieldTouched("zoneId", false);
                      setFieldError("zoneId", "");
                      if (e.target.value) {
                        fetchCircles(e.target.value);
                        fetchWards(e.target.value);
                      } else {
                        fetchCircles([]);
                        fetchWards([]);
                      }
                    }}
                  >
                    <option value="">Select</option>
                    {zones
                      .filter((zone) => zone.isActive)
                      .map((zone) => (
                        <option key={zone.zoneId} value={zone.zoneId}>
                          {zone.zoneName}
                        </option>
                      ))}
                  </Field>
                  <ErrorMessage
                    className="form-text text-danger"
                    name="zoneId"
                    component="div"
                  />
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label className="form-label">
                    Ward
                    {[1, 2].includes(Number(values.collectionTypeId)) && (
                      <span style={{ color: "#EC1117" }}> *</span>
                    )}
                  </label>
                  <Field
                    as="select"
                    name="circleId"
                    className="form-select"
                    onChange={(e) => {
                      setFieldValue("circleId", e.target.value);
                      setFieldValue("wardId", "");
                      setFieldTouched("circleId", false);
                      setFieldError("circleId", "");
                      if (e.target.value) {
                        fetchWards(e.target.value);
                      } else {
                        fetchWards([]);
                      }
                    }}
                  >
                    <option value="">Select</option>
                    {Array.isArray(circles) && circles.length > 0 ? (
                      circles.map((circle) => (
                        <option key={circle.circleId} value={circle.circleId}>
                          {circle.circleName}
                        </option>
                      ))
                    ) : (
                      <option value="" disabled>
                        No Wards found
                      </option>
                    )}
                  </Field>
                  <ErrorMessage
                    className="form-text text-danger"
                    name="circleId"
                    component="div"
                  />
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group" title={values.DriverName + " " + values.DriverNumber}>
                  <label className="form-label">
                    Driver Name
                    {[1].includes(Number(values.collectionTypeId)) && (
                      <span style={{ color: "#EC1117" }}> *</span>
                    )}
                  </label>
                  <Field name="driverId">
                    {({ field, form }) => (
                      <Select
                        {...field}
                        options={drivers
                          .filter((driver) => driver.isActive)
                          .map((driver) => ({
                            value: driver.driverId,
                            label: `${driver.driverName} [${driver.mobileNumber}]`,
                          }))}
                        classNamePrefix="CreatableSelect"
                        placeholder="Select"
                        value={drivers
                          .filter((driver) => driver.isActive)
                          .map((driver) => ({
                            value: driver.driverId,
                            label: `${driver.driverName} [${driver.mobileNumber}]`,
                          }))
                          .find((option) => option.value === field.value)}
                        onChange={(selectedOption) => {
                          const selectedDriverId = selectedOption ? selectedOption.value : '';
                          form.setFieldValue("driverId", selectedDriverId);
                          const selectedDriver = drivers.find(
                            (driver) => driver.driverId === Number(selectedDriverId)
                          );
                          if (selectedDriver) {
                            setFieldValue("DriverName", selectedDriver.driverName);
                            setFieldValue("DriverNumber", selectedDriver.mobileNumber);
                            setFieldTouched("driverId", false);
                            setFieldError("driverId", "");
                          } else {
                            setFieldValue("DriverName", "");
                            setFieldValue("DriverNumber", "");
                          }
                        }}
                        onBlur={() => setFieldTouched("driverId", true)}
                        isClearable={true}
                        isSearchable={true}
                      />
                    )}
                  </Field>
                  <ErrorMessage
                    className="form-text text-danger"
                    name="driverId"
                    component="div"
                  />
                </div>
              </div>
              {Number(values.collectionTypeId) === 1 && (
                <div className="col-md-4">
                  <div className="form-group" title={values.PrimaryDeploymentInchargeName + " " + values.PrimaryDeploymentInchargeNumber}>
                    <label className="form-label">
                      SFA Incharge
                      <span style={{ color: "#EC1117" }}> *</span>
                    </label>
                    <Field name="primaryDeploymentInchargeId">
                      {({ field, form }) => (
                        <Select
                          {...field}
                          options={primaryDeploymentIncharges
                            .filter((incharge) => incharge.isActive)
                            .map((incharge) => ({
                              value: incharge.primaryDeploymentInchargeId,
                              label: `${incharge.primaryDeploymentInchargeName} [${incharge.mobileNumber}]`,
                            }))}
                          classNamePrefix="CreatableSelect"
                          placeholder="Select"
                          value={primaryDeploymentIncharges
                            .filter((incharge) => incharge.isActive)
                            .map((incharge) => ({
                              value: incharge.primaryDeploymentInchargeId,
                              label: `${incharge.primaryDeploymentInchargeName} [${incharge.mobileNumber}]`,
                            }))
                            .find((option) => option.value === field.value)}
                          onChange={(selectedOption) => {
                            const selectedPrimaryDeploymentInchargeId = selectedOption ? selectedOption.value : '';
                            form.setFieldValue("primaryDeploymentInchargeId", selectedPrimaryDeploymentInchargeId);
                            const selectedIncharge = primaryDeploymentIncharges.find(
                              (incharge) => incharge.primaryDeploymentInchargeId === Number(selectedPrimaryDeploymentInchargeId)
                            );
                            if (selectedIncharge) {
                              setFieldValue("PrimaryDeploymentInchargeName", selectedIncharge.primaryDeploymentInchargeName);
                              setFieldValue("PrimaryDeploymentInchargeNumber", selectedIncharge.mobileNumber);
                              setFieldTouched("primaryDeploymentInchargeId", false);
                              setFieldError("primaryDeploymentInchargeId", "");
                            } else {
                              setFieldValue("PrimaryDeploymentInchargeName", "");
                              setFieldValue("PrimaryDeploymentInchargeNumber", "");
                            }
                          }}
                          onBlur={() => setFieldTouched("primaryDeploymentInchargeId", true)}
                          isClearable={true}
                          isSearchable={true}
                        />
                      )}
                    </Field>
                    <ErrorMessage
                      className="form-text text-danger"
                      name="primaryDeploymentInchargeId"
                      component="div"
                    />
                  </div>
                </div>
              )}
              {Number(values.collectionTypeId) === 2 && (
                <div className="col-md-4">
                  <div className="form-group" title={values.SecondaryDeploymentInchargeName + " " + values.SecondaryDeploymentInchargeNumber}>
                    <label className="form-label">
                      Deployment Incharge
                    </label>
                    <Field name="secondaryDeploymentInchargeId">
                      {({ field, form }) => (
                        <Select
                          {...field}
                          options={secondaryDeploymentIncharges
                            .filter((incharge) => incharge.isActive)
                            .map((incharge) => ({
                              value: incharge.secondaryDeploymentInchargeId,
                              label: `${incharge.secondaryDeploymentInchargeName} [${incharge.mobileNumber}]`,
                            }))}
                          classNamePrefix="CreatableSelect"
                          placeholder="Select"
                          value={secondaryDeploymentIncharges
                            .filter((incharge) => incharge.isActive)
                            .map((incharge) => ({
                              value: incharge.secondaryDeploymentInchargeId,
                              label: `${incharge.secondaryDeploymentInchargeName} [${incharge.mobileNumber}]`,
                            }))
                            .find((option) => option.value === field.value)}
                          onChange={(selectedOption) => {
                            const selectedSecondaryDeploymentInchargeId = selectedOption ? selectedOption.value : '';
                            form.setFieldValue("secondaryDeploymentInchargeId", selectedSecondaryDeploymentInchargeId);
                            const selectedIncharge = secondaryDeploymentIncharges.find(
                              (incharge) => incharge.secondaryDeploymentInchargeId === Number(selectedSecondaryDeploymentInchargeId)
                            );
                            if (selectedIncharge) {
                              form.setFieldValue("SecondaryDeploymentInchargeName", selectedIncharge.secondaryDeploymentInchargeName);
                              form.setFieldValue("SecondaryDeploymentInchargeNumber", selectedIncharge.mobileNumber);
                              form.setFieldTouched("secondaryDeploymentInchargeId", false);
                              form.setFieldError("secondaryDeploymentInchargeId", "");
                            } else {
                              form.setFieldValue("SecondaryDeploymentInchargeName", "");
                              form.setFieldValue("SecondaryDeploymentInchargeNumber", "");
                            }
                          }}
                          onBlur={() => form.setFieldTouched("secondaryDeploymentInchargeId", true)}
                          isClearable={true}
                          isSearchable={true}
                        />
                      )}
                    </Field>
                    <ErrorMessage
                      className="form-text text-danger"
                      name="secondaryDeploymentInchargeId"
                      component="div"
                    />
                  </div>
                </div>
              )}
              <div className="col-md-4">
                <div className="form-group" title={values.transferStationName}>
                  <label className="form-label">
                    Transfer Station
                  </label>
                  <Field name="transferStationId">
                    {({ field, form }) => (
                      <Select
                        {...field}
                        options={transferStations
                          .filter((station) => station.isActive)
                          .map((station) => ({
                            value: station.transferStationId,
                            label: station.transferStationName,
                          }))}
                        classNamePrefix="CreatableSelect"
                        placeholder="Select"
                        value={transferStations
                          .filter((station) => station.isActive)
                          .map((station) => ({
                            value: station.transferStationId,
                            label: station.transferStationName,
                          }))
                          .find((option) => option.value === field.value)}
                        onChange={(selectedOption) => {
                          const selectedTransferStationId = selectedOption ? selectedOption.value : '';
                          form.setFieldValue("transferStationId", selectedTransferStationId);
                          const selectedStation = transferStations.find(
                            (station) => station.transferStationId === Number(selectedTransferStationId)
                          );
                          if (selectedStation) {
                            form.setFieldValue("transferStationName", selectedStation.transferStationName);
                            form.setFieldTouched("transferStationId", false);
                            form.setFieldError("transferStationId", "");
                          } else {
                            form.setFieldValue("transferStationName", "");
                          }
                        }}
                        onBlur={() => form.setFieldTouched("transferStationId", true)}
                        isClearable={true}
                        isSearchable={true}
                      />
                    )}
                  </Field>
                  <ErrorMessage
                    className="form-text text-danger"
                    name="transferStationId"
                    component="div"
                  />
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label className="form-label">Vehicle Category</label>
                  <Field as="select" name="vehicleCategoryId" className="form-select">
                    <option value="">Select</option>
                    {vehicleCategoryData?.map((item) => (
                        <option key={item.vehicleCategoryId} value={item.vehicleCategoryId}>
                          {item.vehicleCategoryName}
                        </option>
                      ))}
                  </Field>
                  <ErrorMessage
                    className="form-text text-danger"
                    name="vehicleCategoryId"
                    component="span"
                  />
                </div>
              </div>
              <div className="col-12">
                <div className="row">
                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="vehicleImageUrl" className="form-label">
                        Vehicle Insurance
                      </label>
                      <input
                        type="file"
                        id="vehicleImageUrl"
                        name="vehicleImageUrl"
                        accept=".png, .jpg, .jpeg"
                        onChange={(e) => {
                          handleFileChange(e, 'vehicleImageUrl');
                          setFieldValue('vehicleImageUrl', e.currentTarget.files[0]);
                        }}
                        className="form-control"
                      />
                      <ErrorMessage
                        className="form-text text-danger"
                        name="vehicleImageUrl"
                        component="div"
                      />
                      {filePreviews.vehicleImageUrl?.fileUrl && (
                        <FilePreview
                          file={filePreviews.vehicleImageUrl.file}
                          fileType={filePreviews.vehicleImageUrl.fileType}
                          fileUrl={filePreviews.vehicleImageUrl.fileUrl}
                        />
                      )}
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="rcimageUrl" className="form-label">
                        Registration Certificate
                      </label>
                      <input
                        type="file"
                        id="rcimageUrl"
                        name="rcimageUrl"
                        accept="image/png, image/jpeg, image/jpg"
                        onChange={(e) => {
                          handleFileChange(e, 'rcimageUrl');
                          setFieldValue('rcimageUrl', e.currentTarget.files[0]);
                        }}
                        className="form-control"
                      />
                      <ErrorMessage
                        className="form-text text-danger"
                        name="rcimageUrl"
                        component="div"
                      />
                      {filePreviews.rcimageUrl?.fileUrl && (
                        <FilePreview
                          file={filePreviews.rcimageUrl.file}
                          fileType={filePreviews.rcimageUrl.fileType}
                          fileUrl={filePreviews.rcimageUrl.fileUrl}
                        />
                      )}
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="pcimageUrl" className="form-label">
                        Pollution Certificate
                      </label>
                      <input
                        type="file"
                        id="pcimageUrl"
                        name="pcimageUrl"
                        accept=".png, .jpg, .jpeg"
                        onChange={(e) => {
                          handleFileChange(e, 'pcimageUrl');
                          setFieldValue('pcimageUrl', e.currentTarget.files[0]);
                        }}
                        className="form-control"
                      />
                      <ErrorMessage
                        className="form-text text-danger"
                        name="pcimageUrl"
                        component="div"
                      />
                      {filePreviews.pcimageUrl?.fileUrl && (
                        <FilePreview
                          file={filePreviews.pcimageUrl.file}
                          fileType={filePreviews.pcimageUrl.fileType}
                          fileUrl={filePreviews.pcimageUrl.fileUrl}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <BaseFormComponent
                label="Vehicle Brand Name"
                name="vehicleBrandName"
                type="text"
                placeholder="Enter Vehicle Brand Name"
                max="42"
                handleSpecialCharacters={handleSpecialCharacters}
              />
              <BaseFormComponent
                label="Contractor Name"
                name="contractorName"
                type="text"
                placeholder="Enter Contractor Name"
                max="42"
                handleSpecialCharacters={handleSpecialCharacters}
              />
              <BaseFormComponent
                label="RFID"
                name="RFID"
                type="text"
                placeholder="Enter RFID"
                max="12"
                handleSpecialCharacters={handleSpecialCharacters}
              />
              <div className="col-md-12 mb-3">
                <div className="form-group">
                  <label htmlFor="remark" className="form-label">
                    Remarks
                  </label>
                  <Field
                    as="textarea"
                    id="remark"
                    name="remark"
                    className="form-control"
                    maxLength="500"
                    rows="3"
                  />
                  <ErrorMessage
                    className="form-text text-danger"
                    name="remark"
                    component="div"
                  />
                </div>
              </div>
              <div className="row" style={{ marginTop: '5px' }}>
                <div className="col-md-4">
                  <label className="form-label">
                    Status <span style={{ color: '#EC1117' }}>*</span>
                  </label>
                  <div className="d-flex gap-4">
                    <div className="form-group d-flex justify-content-center align-items-center gap-2">
                      <div className="radio-button-group">
                        <Field name="isActive">
                          {({ field }) => (
                            <input
                              type="radio"
                              id="active"
                              {...field}
                              value={true}
                              checked={values.isActive === true}
                              onChange={() => setFieldValue('isActive', true)}
                            />
                          )}
                        </Field>
                      </div>
                      <label htmlFor="active">Active</label>
                    </div>
                    <div className="form-group d-flex justify-content-center align-items-center gap-2">
                      <div className="radio-button-group">
                        <Field name="isActive">
                          {({ field }) => (
                            <input
                              type="radio"
                              id="inactive"
                              {...field}
                              value={false}
                              checked={values.isActive === false}
                              onChange={() => setFieldValue('isActive', false)}
                            />
                          )}
                        </Field>
                      </div>
                      <label htmlFor="inactive">Inactive</label>
                    </div>
                  </div>
                  <ErrorMessage
                    className="form-text text-danger"
                    name="isActive"
                    component="div"
                  />
                </div>
              </div>
              <div className="modal-footer d-flex justify-content-center">
                {/* {canWrite === true ? ( */}
                  <button
                    type="submit"
                    className="deployment-button"
                    disabled={isSubmit}
                  >
                    {isSubmit ? (
                      <l-waveform
                        size="20"
                        stroke="3.5"
                        speed="1"
                        color="black"
                      ></l-waveform>
                    ) : (
                      <>
                        <i className="fa-solid fa-check done-container"></i>
                        {editVehicleData ? 'Update' : 'Save'}
                      </>
                    )}
                  </button>
                {/* ) : (
                  ''
                )} */}
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default AddVehicleForm;
































// import React, { useEffect, useState } from 'react';
// import BaseFormComponent from "./form_fields/BaseFormComponent";
// import Select from 'react-select';
// import { toast } from 'react-toastify';
// import { useDropdownStore } from './store/useDropdownStore';
// import { Formik, Form, ErrorMessage, Field } from 'formik';
// import FilePreview from './FilePreview';
// import { useVehicleStore } from './store/useVehicleStore';
// import getValidationSchema from './getValidationSchema';
// import { waveform } from 'ldrs';
// import { handleUuid } from '../../../utils/ValidationsHelper';
// import { getWritePermission } from './utils/helpers';
// import axiosInstance from '../../../Hooks/axoisInstance';
// import { API_BASE_URL1 } from '../../Services/baseApiUrl';

// const AddVehicleForm = ({
//   handleSearch,
//   editVehicleData,
//   setEditVehicleData,
//   handleClose,
// }) => {
//   const {
//     fuelTypes,
//     collectionTypes,
//     vehicleTypes,
//     ownerTypes,
//     vehicleCapacities,
//     zones,
//     circles,
//     wards,
//     drivers,
//     primaryDeploymentIncharges,
//     secondaryDeploymentIncharges,
//     transferStations,
//     loading,
//     vehicleStatus,
//     fileInputs,
//     filePreviews,
//     resetFileInputs,
//     fetchVehicleTypes,
//     fetchOwnerTypes,
//     fetchVehicleCapacities,
//     fetchVehicleStatus,
//     fetchFuelTypes,
//     fetchCollectionTypes,
//     fetchZones,
//     fetchCircles,
//     fetchWards,
//     fetchDrivers,
//     fetchPrimaryDeploymentIncharges,
//     fetchSecondaryDeploymentIncharges,
//     fetchTransferStations,
//     handleFileChange,
//     updateFilePreview,
//   } = useDropdownStore();
//   const canWrite = getWritePermission();
//   const {
//     saveVehicleDetails,
//     fetchVehicleDetails,
//     vehicleDetails,
//     isSaveVehicleDetailsLoading,
//     error,
//     success,
//   } = useVehicleStore();

//   const [collectionPoints, setCollectionPoints] = useState([]);
//   const [tripRows, setTripRows] = useState([]);

//   const getToken = () => localStorage.getItem('token');

//   const fetchCollectionPoints = async () => {
//     try {
//       const collectionPointsData = await axiosInstance.get(
//         `${API_BASE_URL1}Routes/GetAllCollectionPoints`,
//         {
//           headers: {
//             Authorization: `Bearer ${getToken()}`,
//           },
//         }
//       );
//       setCollectionPoints(collectionPointsData.data.filter((cp) => cp.isActive));
//     } catch (error) {
//       console.error('Error fetching collection points:', error);
//       toast.error('Failed to fetch collection points');
//     }
//   };

//   useEffect(() => {
//     fetchCollectionPoints();
//     fetchFuelTypes();
//     fetchCollectionTypes();
//     fetchVehicleStatus();
//     fetchOwnerTypes();
//     fetchZones();
//     fetchDrivers();
//     fetchPrimaryDeploymentIncharges();
//     fetchSecondaryDeploymentIncharges();
//     fetchTransferStations();
//     if (editVehicleData) {
//       fetchVehicleTypes(editVehicleData?.collectionTypeId);
//       fetchVehicleCapacities(editVehicleData?.vehicleTypeId);
//       fetchCircles(editVehicleData?.zoneId);
//       fetchWards(editVehicleData?.circleId);
//       fetchDrivers(editVehicleData?.collectionTypeId);
//       updateFilePreview(
//         editVehicleData?.vehicleImageUrl ?? null,
//         editVehicleData?.rcimageUrl ?? null,
//         editVehicleData?.pcimageUrl ?? null
//       );
//       if (editVehicleData?.trips?.length > 0) {
//         setTripRows(
//           editVehicleData.trips.map((trip, index) => ({
//             id: Date.now() + index,
//             primaryCollectionPointId: trip.primaryCollectionPointId || '',
//             secondaryCollectionPointId: trip.secondaryCollectionPointId || '',
//             shifts: trip.shifts || [],
//           }))
//         );
//       }
//     }
//   }, [editVehicleData]);

//   const initialVehicleDetails = {
//     vehicleNumber: editVehicleData?.vehicleNumber || '',
//     chassisNumber: editVehicleData?.chassisNumber || '',
//     fuelTypeId: editVehicleData?.fuelTypeId || '',
//     collectionTypeId: editVehicleData?.collectionTypeId || '',
//     vehicleTypeId: editVehicleData?.vehicleTypeId || '',
//     vehicleCapacityId: editVehicleData?.vehicleCapacityId || '',
//     vehicleStatusId: editVehicleData?.vehicleStatusId || '',
//     ownerTypeId: editVehicleData?.ownerTypeId || '',
//     vehicleUuid: editVehicleData?.vehicleUuid || '',
//     zoneId: editVehicleData?.zoneId || '',
//     circleId: editVehicleData?.circleId || '',
//     driverId: editVehicleData?.driverId || '',
//     RFID: editVehicleData?.rfid || '',
//     primaryDeploymentInchargeId: editVehicleData?.primaryDeploymentInchargeId || '',
//     secondaryDeploymentInchargeId: editVehicleData?.secondaryDeploymentInchargeId || '',
//     vehicleCategoryId: editVehicleData?.vehicleCategoryId || '',
//     vehicleImageUrl: null,
//     rcimageUrl: null,
//     pcimageUrl: null,
//     vehicleBrandName: editVehicleData?.vehicleBrandName || '',
//     contractorName: editVehicleData?.contractorName || '',
//     remark: editVehicleData?.remark || '',
//     isActive: editVehicleData?.isActive || true,
//     fuelTypeName: editVehicleData?.fuelTypeName || '',
//     collectionTypeName: editVehicleData?.collectionTypeName || '',
//     ownerTypeName: editVehicleData?.ownerTypeName || '',
//     transferStationName: editVehicleData?.transferStationName || '',
//     vehicleTypeName: editVehicleData?.vehicleTypeName || '',
//     vehicleCapacityName: editVehicleData?.vehicleCapacityName || '',
//     vehicleStatusName: editVehicleData?.vehicleStatusName || '',
//     DriverNumber: editVehicleData?.driverNumber || '',
//     DriverName: editVehicleData?.driverName || '',
//     PrimaryDeploymentInchargeName: editVehicleData?.primaryDeploymentInchargeName || '',
//     PrimaryDeploymentInchargeNumber: editVehicleData?.primaryDeploymentInchargeNumber || '',
//     SecondaryDeploymentInchargeNumber: editVehicleData?.SecondaryDeploymentInchargeNumber || '',
//     SecondaryDeploymentInchargeName: editVehicleData?.secondaryDeploymentInchargeName || '',
//     trips: editVehicleData?.trips || [],
//     ...(editVehicleData?.vehicleId && { vehicleId: editVehicleData.vehicleId }),
//   };

//   const [collectionTypeId, setCollectionTypeId] = useState(
//     initialVehicleDetails.collectionTypeId
//   );
//   const [isSubmit, setIsSubmit] = useState(false);
//   waveform.register();

//   const addTripRow = () => {
//     setTripRows([
//       ...tripRows,
//       {
//         id: Date.now(),
//         primaryCollectionPointId: '',
//         secondaryCollectionPointId: '',
//         shifts: [],
//       },
//     ]);
//   };

//   const removeTripRow = (id) => {
//     setTripRows(tripRows.filter((row) => row.id !== id));
//   };

//   const getAvailableCollectionPoints = (currentRowId, fieldType) => {
//     const currentRow = tripRows.find((row) => row.id === currentRowId);
//     const excludedId =
//       fieldType === 'primary'
//         ? currentRow?.secondaryCollectionPointId
//         : currentRow?.primaryCollectionPointId;

//     return collectionPoints
//       .filter((cp) => !excludedId || cp.collectionPointId !== excludedId)
//       .map((cp) => ({
//         value: cp.collectionPointId,
//         label: cp.collectionPointCode,
//       }));
//   };

//   const handleShiftChange = (rowId, shift) => {
//     setTripRows(
//       tripRows.map((row) => {
//         if (row.id === rowId) {
//           const updatedShifts = row.shifts.includes(shift)
//             ? row.shifts.filter((s) => s !== shift)
//             : [...row.shifts, shift];
//           return { ...row, shifts: updatedShifts };
//         }
//         return row;
//       })
//     );
//   };

//   const handleSubmit = async (values, { resetForm, setErrors }) => {
//     setIsSubmit(true);
//     const formattedValues = {
//       ...values,
//       wardId: values.wardId ? values.wardId : undefined,
//       PrimaryDeploymentInchargeName:
//         values.collectionTypeId === '2' ? '' : values.PrimaryDeploymentInchargeName,
//       PrimaryDeploymentInchargeNumber:
//         values.collectionTypeId === '2' ? '' : values.PrimaryDeploymentInchargeNumber,
//       SecondaryDeploymentInchargeNumber:
//         values.collectionTypeId === '1' ? '' : values.SecondaryDeploymentInchargeNumber,
//       SecondaryDeploymentInchargeName:
//         values.collectionTypeId === '1' ? '' : values.SecondaryDeploymentInchargeName,
//       trips: tripRows.map((row) => ({
//         primaryCollectionPointId: row.primaryCollectionPointId,
//         secondaryCollectionPointId: row.secondaryCollectionPointId,
//         shifts: row.shifts,
//       })),
//     };
//     try {
//       const response = await saveVehicleDetails(formattedValues, editVehicleData);
//       handleSearch();
//       toast.success(
//         editVehicleData
//           ? 'Vehicle updated successfully'
//           : 'New Vehicle added successfully'
//       );
//       setEditVehicleData(null);
//       handleClose();
//       resetFileInputs();
//       setIsSubmit(false);
//     } catch (xhr) {
//       console.log('xhr.errors:', xhr);
//       if (xhr && xhr.response && typeof xhr.response.data.errors === 'object') {
//         const formErrors = {};
//         Object.keys(xhr.response.data.errors).forEach((key) => {
//           if (
//             Array.isArray(xhr.response.data.errors[key]) &&
//             xhr.response.data.errors[key].length > 0
//           ) {
//             formErrors[key] = xhr.response.data.errors[key][0];
//             toast.error(`${key}: ${xhr.response.data.errors[key][0]}`);
//           }
//         });
//       } else {
//         toast.error(xhr.response.data);
//       }
//       setIsSubmit(false);
//     }
//     resetForm();
//   };

//   const handleSpecialCharacters = (e) => {
//     const value = e.target.value;
//     const sanitizedValue = value
//       .replace(/[^a-zA-Z0-9\s]/g, '')
//       .replace(/^\s+/, '')
//       .replace(/\s{2,}/g, ' ');
//     e.target.value = sanitizedValue;
//   };

//   return (
//     <div>
//       <Formik
//         initialValues={initialVehicleDetails}
//         validationSchema={getValidationSchema(collectionTypeId, editVehicleData)}
//         onSubmit={handleSubmit}
//         validateOnChange={true}
//         validateOnBlur={true}
//       >
//         {({
//           values,
//           setFieldValue,
//           setFieldError,
//           resetForm,
//           setFieldTouched,
//           setErrors,
//           setTouched,
//         }) => (
//           <Form>
//             <div className="row">
//               <BaseFormComponent
//                 label="Vehicle Number"
//                 name="vehicleNumber"
//                 type="text"
//                 placeholder="Enter Vehicle Registration Number"
//                 required
//               />
//               <BaseFormComponent
//                 label="Vehicle Chassis Number"
//                 name="chassisNumber"
//                 type="text"
//                 max="30"
//                 handleSpecialCharacters={handleSpecialCharacters}
//                 placeholder="Enter Vehicle Chassis Number"
//               />
//               <div className="col-md-4">
//                 <div className="form-group">
//                   <label className="form-label">
//                     Fuel Type <span style={{ color: '#EC1117' }}>*</span>
//                   </label>
//                   <Field
//                     as="select"
//                     name="fuelTypeId"
//                     className="form-select"
//                     onChange={(e) => {
//                       const selectedFuelTypeId = e.target.value;
//                       setFieldValue('fuelTypeId', selectedFuelTypeId);
//                       setFieldTouched('fuelTypeId', false);
//                       setFieldError('fuelTypeId', '');
//                       const selectedFuelType = fuelTypes.find(
//                         (fuelType) => fuelType.fuelTypeId === Number(selectedFuelTypeId)
//                       );
//                       if (selectedFuelType) {
//                         setFieldValue('fuelTypeName', selectedFuelType.fuelTypeName);
//                       }
//                     }}
//                   >
//                     <option value="">Select</option>
//                     {fuelTypes.map((fuelType) => (
//                       <option key={fuelType.fuelTypeId} value={fuelType.fuelTypeId}>
//                         {fuelType.fuelTypeName}
//                       </option>
//                     ))}
//                   </Field>
//                   <ErrorMessage
//                     className="form-text text-danger"
//                     name="fuelTypeId"
//                     component="span"
//                   />
//                 </div>
//               </div>
//               <div className="col-md-4">
//                 <div className="form-group">
//                   <label className="form-label">
//                     Collection Type <span style={{ color: '#EC1117' }}>*</span>
//                   </label>
//                   <Field
//                     as="select"
//                     name="collectionTypeId"
//                     className="form-select"
//                     onChange={(e) => {
//                       const selectedValue = e.target.value;
//                       const previousValue = values.collectionTypeId;
//                       setFieldValue('collectionTypeId', selectedValue);
//                       setFieldTouched('collectionTypeId', false);
//                       setFieldError('collectionTypeId', '');
//                       if (previousValue === '1' && selectedValue !== '1') {
//                         setFieldValue('driverId', '');
//                         setFieldTouched('driverId', false);
//                         setFieldError('driverId', '');
//                       }
//                       if (selectedValue) {
//                         setCollectionTypeId(selectedValue);
//                         fetchVehicleTypes(selectedValue);
//                         fetchDrivers(selectedValue);
//                         if (selectedValue === '1') {
//                           fetchPrimaryDeploymentIncharges();
//                         } else if (selectedValue === '2') {
//                           fetchSecondaryDeploymentIncharges();
//                         }
//                       }
//                       const selectedCollectionType = collectionTypes.find(
//                         (collectionType) =>
//                           collectionType.collectionTypeId === Number(selectedValue)
//                       );
//                       if (selectedCollectionType) {
//                         setFieldValue(
//                           'collectionTypeName',
//                           selectedCollectionType.collectionTypeName
//                         );
//                       }
//                     }}
//                   >
//                     <option value="">Select</option>
//                     {collectionTypes.map((collectionType) => (
//                       <option
//                         key={collectionType.collectionTypeId}
//                         value={collectionType.collectionTypeId}
//                       >
//                         {collectionType.collectionTypeName}
//                       </option>
//                     ))}
//                   </Field>
//                   <ErrorMessage
//                     className="form-text text-danger"
//                     name="collectionTypeId"
//                     component="span"
//                   />
//                 </div>
//               </div>
//               <div className="col-md-4">
//                 <div className="form-group">
//                   <label className="form-label">
//                     Vehicle Type <span style={{ color: '#EC1117' }}>*</span>
//                   </label>
//                   <Field
//                     as="select"
//                     name="vehicleTypeId"
//                     className="form-select"
//                     onChange={(e) => {
//                       setFieldValue('vehicleTypeId', e.target.value);
//                       setFieldTouched('vehicleTypeId', false);
//                       setFieldError('vehicleTypeId', '');
//                       if (e.target.value) {
//                         fetchVehicleCapacities(e.target.value);
//                       }
//                       const selectedVehicleTypeId = e.target.value;
//                       const selectedVehicleType = vehicleTypes.find(
//                         (vehicleType) =>
//                           vehicleType.vehicleTypeId === Number(selectedVehicleTypeId)
//                       );
//                       if (selectedVehicleType) {
//                         setFieldValue('vehicleTypeName', selectedVehicleType.vehicleTypeName);
//                       }
//                     }}
//                   >
//                     <option value="">Select</option>
//                     {vehicleTypes
//                       .filter((vehicleType) => vehicleType.isActive)
//                       .map((vehicleType) => (
//                         <option
//                           key={vehicleType.vehicleTypeId}
//                           value={vehicleType.vehicleTypeId}
//                         >
//                           {vehicleType.vehicleTypeName}
//                         </option>
//                       ))}
//                   </Field>
//                   <ErrorMessage
//                     className="form-text text-danger"
//                     name="vehicleTypeId"
//                     component="span"
//                   />
//                 </div>
//               </div>
//               <div className="col-md-4">
//                 <div className="form-group">
//                   <label className="form-label">
//                     Vehicle Capacity <span style={{ color: '#EC1117' }}>*</span>
//                   </label>
//                   <Field
//                     as="select"
//                     name="vehicleCapacityId"
//                     className="form-select"
//                     onChange={(e) => {
//                       const selectedVehicleCapacityId = e.target.value;
//                       setFieldValue('vehicleCapacityId', e.target.value);
//                       setFieldTouched('vehicleCapacityId', false);
//                       setFieldError('vehicleCapacityId', '');
//                       const selectedVehicleCapacity = vehicleCapacities.find(
//                         (vehicleCapacity) =>
//                           vehicleCapacity.vehicleCapacityId ===
//                           Number(selectedVehicleCapacityId)
//                       );
//                       if (selectedVehicleCapacity) {
//                         setFieldValue(
//                           'vehicleCapacityName',
//                           selectedVehicleCapacity.vehicleCapacityName
//                         );
//                       }
//                     }}
//                   >
//                     <option value="">Select</option>
//                     {vehicleCapacities
//                       .filter((vehicleCapacity) => vehicleCapacity.isActive)
//                       .map((vehicleCapacity) => (
//                         <option
//                           key={vehicleCapacity.vehicleCapacityId}
//                           value={vehicleCapacity.vehicleCapacityId}
//                         >
//                           {vehicleCapacity.vehicleCapacityName}
//                         </option>
//                       ))}
//                   </Field>
//                   <ErrorMessage
//                     className="form-text text-danger"
//                     name="vehicleCapacityId"
//                     component="span"
//                   />
//                 </div>
//               </div>
//               <div className="col-md-4">
//                 <div className="form-group">
//                   <label className="form-label">
//                     Vehicle Status <span style={{ color: '#EC1117' }}>*</span>
//                   </label>
//                   <Field
//                     as="select"
//                     name="vehicleStatusId"
//                     className="form-select"
//                     onChange={(e) => {
//                       const selectedVehicleStatusId = e.target.value;
//                       setFieldValue('vehicleStatusId', e.target.value);
//                       setFieldTouched('vehicleStatusId', false);
//                       setFieldError('vehicleStatusId', '');
//                       const selectedVehicleStatus = vehicleStatus.find(
//                         (vehicleStatus) =>
//                           vehicleStatus.vehicleStatusId === Number(selectedVehicleStatusId)
//                       );
//                       Number(selectedVehicleStatusId) === 2
//                         ? setFieldValue('isActive', false)
//                         : setFieldValue('isActive', true);
//                       setFieldValue(
//                         'vehicleStatusName',
//                         selectedVehicleStatus?.vehicleStatusName
//                       );
//                     }}
//                   >
//                     <option value="">Select</option>
//                     {vehicleStatus.map((status) => (
//                       <option
//                         key={status.vehicleStatusId}
//                         value={status.vehicleStatusId}
//                       >
//                         {status.vehicleStatusName}
//                       </option>
//                     ))}
//                   </Field>
//                   <ErrorMessage
//                     className="form-text text-danger"
//                     name="vehicleStatusId"
//                     component="span"
//                   />
//                 </div>
//               </div>
//               <div className="col-md-4">
//                 <div className="form-group">
//                   <label className="form-label">
//                     Owner Type <span style={{ color: '#EC1117' }}>*</span>
//                   </label>
//                   <Field
//                     as="select"
//                     name="ownerTypeId"
//                     className="form-select"
//                     onChange={(e) => {
//                       const selectedOwnerTypeId = e.target.value;
//                       setFieldValue('ownerTypeId', e.target.value);
//                       setFieldTouched('ownerTypeId', false);
//                       setFieldError('ownerTypeId', '');
//                       const selectedOwnerType = ownerTypes.find(
//                         (ownerType) =>
//                           ownerType.ownerTypeId === Number(selectedOwnerTypeId)
//                       );
//                       if (selectedOwnerType) {
//                         setFieldValue('ownerTypeName', selectedOwnerType.ownerTypeName);
//                       }
//                     }}
//                   >
//                     <option value="">Select</option>
//                     {ownerTypes
//                       .filter((owner) => owner.isActive)
//                       .map((owner) => (
//                         <option key={owner.ownerTypeId} value={owner.ownerTypeId}>
//                           {owner.ownerTypeName}
//                         </option>
//                       ))}
//                   </Field>
//                   <ErrorMessage
//                     className="form-text text-danger"
//                     name="ownerTypeId"
//                     component="span"
//                   />
//                 </div>
//               </div>
//               <div className="col-md-4">
//                 <div className="form-group">
//                   <label className="form-label">
//                     Vehicle UID <span style={{ color: '#EC1117' }}>*</span>
//                   </label>
//                   <Field
//                     type="text"
//                     id="vehicleUuid"
//                     maxLength="20"
//                     name="vehicleUuid"
//                     onInput={handleUuid}
//                     className="form-control"
//                     placeholder="Enter Vehicle UID"
//                   />
//                   <ErrorMessage
//                     className="form-text text-danger"
//                     name="vehicleUuid"
//                     component="span"
//                   />
//                 </div>
//               </div>
//               <div className="col-md-4">
//                 <div className="form-group">
//                   <label className="form-label">
//                     Zone <span style={{ color: '#EC1117' }}>*</span>
//                   </label>
//                   <Field
//                     as="select"
//                     name="zoneId"
//                     className="form-select"
//                     onChange={(e) => {
//                       setFieldValue('zoneId', e.target.value);
//                       setFieldValue('circleId', '');
//                       setFieldValue('wardId', '');
//                       setFieldTouched('zoneId', false);
//                       setFieldError('zoneId', '');
//                       if (e.target.value) {
//                         fetchCircles(e.target.value);
//                         fetchWards(e.target.value);
//                       } else {
//                         fetchCircles([]);
//                         fetchWards([]);
//                       }
//                     }}
//                   >
//                     <option value="">Select</option>
//                     {zones
//                       .filter((zone) => zone.isActive)
//                       .map((zone) => (
//                         <option key={zone.zoneId} value={zone.zoneId}>
//                           {zone.zoneName}
//                         </option>
//                       ))}
//                   </Field>
//                   <ErrorMessage
//                     className="form-text text-danger"
//                     name="zoneId"
//                     component="span"
//                   />
//                 </div>
//               </div>
//               <div className="col-md-4">
//                 <div className="form-group">
//                   <label className="form-label">
//                     Ward
//                     {[1, 2].includes(Number(values.collectionTypeId)) && (
//                       <span style={{ color: '#EC1117' }}>*</span>
//                     )}
//                   </label>
//                   <Field
//                     as="select"
//                     name="circleId"
//                     className="form-select"
//                     onChange={(e) => {
//                       setFieldValue('circleId', e.target.value);
//                       setFieldValue('wardId', '');
//                       setFieldTouched('circleId', false);
//                       setFieldError('circleId', '');
//                       if (e.target.value) {
//                         fetchWards(e.target.value);
//                       } else {
//                         fetchWards([]);
//                       }
//                     }}
//                   >
//                     <option value="">Select</option>
//                     {Array.isArray(circles) && circles.length > 0 ? (
//                       circles.map((circle) => (
//                         <option key={circle.circleId} value={circle.circleId}>
//                           {circle.circleName}
//                         </option>
//                       ))
//                     ) : (
//                       <option value="" disabled>
//                         No Wards found
//                       </option>
//                     )}
//                   </Field>
//                   <ErrorMessage
//                     className="form-text text-danger"
//                     name="circleId"
//                     component="span"
//                   />
//                 </div>
//               </div>
//               <div className="col-md-4">
//                 <div className="form-group" title={`${values.DriverName} ${values.DriverNumber}`}>
//                   <label className="form-label">
//                     Driver Name
//                     {[1].includes(Number(values.collectionTypeId)) && (
//                       <span style={{ color: '#EC1117' }}>*</span>
//                     )}
//                   </label>
//                   <Field name="driverId">
//                     {({ field, form }) => (
//                       <Select
//                         {...field}
//                         options={drivers
//                           .filter((driver) => driver.isActive)
//                           .map((driver) => ({
//                             value: driver.driverId,
//                             label: `${driver.driverName} [${driver.mobileNumber}]`,
//                           }))}
//                         classNamePrefix="CreatableSelect"
//                         placeholder="Select"
//                         value={drivers
//                           .filter((driver) => driver.isActive)
//                           .map((driver) => ({
//                             value: driver.driverId,
//                             label: `${driver.driverName} [${driver.mobileNumber}]`,
//                           }))
//                           .find((option) => option.value === field.value)}
//                         onChange={(selectedOption) => {
//                           const selectedDriverId = selectedOption
//                             ? selectedOption.value
//                             : '';
//                           form.setFieldValue('driverId', selectedDriverId);
//                           const selectedDriver = drivers.find(
//                             (driver) => driver.driverId === Number(selectedDriverId)
//                           );
//                           if (selectedDriver) {
//                             setFieldValue('DriverName', selectedDriver.driverName);
//                             setFieldValue('DriverNumber', selectedDriver.mobileNumber);
//                             setFieldTouched('driverId', false);
//                             setFieldError('driverId', '');
//                           } else {
//                             setFieldValue('DriverName', '');
//                             setFieldValue('DriverNumber', '');
//                           }
//                         }}
//                         onBlur={() => setFieldTouched('driverId', true)}
//                         isClearable={true}
//                         isSearchable={true}
//                       />
//                     )}
//                   </Field>
//                   <ErrorMessage
//                     className="form-text text-danger"
//                     name="driverId"
//                     component="span"
//                   />
//                 </div>
//               </div>
//               {Number(values.collectionTypeId) === 1 && (
//                 <div className="col-md-4">
//                   <div
//                     className="form-group"
//                     title={`${values.PrimaryDeploymentInchargeName} ${values.PrimaryDeploymentInchargeNumber}`}
//                   >
//                     <label className="form-label">
//                       SFA Incharge <span style={{ color: '#EC1117' }}>*</span>
//                     </label>
//                     <Field name="primaryDeploymentInchargeId">
//                       {({ field, form }) => (
//                         <Select
//                           {...field}
//                           options={primaryDeploymentIncharges
//                             .filter((incharge) => incharge.isActive)
//                             .map((incharge) => ({
//                               value: incharge.primaryDeploymentInchargeId,
//                               label: `${incharge.primaryDeploymentInchargeName} [${incharge.mobileNumber}]`,
//                             }))}
//                           classNamePrefix="CreatableSelect"
//                           placeholder="Select"
//                           value={primaryDeploymentIncharges
//                             .filter((incharge) => incharge.isActive)
//                             .map((incharge) => ({
//                               value: incharge.primaryDeploymentInchargeId,
//                               label: `${incharge.primaryDeploymentInchargeName} [${incharge.mobileNumber}]`,
//                             }))
//                             .find((option) => option.value === field.value)}
//                           onChange={(selectedOption) => {
//                             const selectedPrimaryDeploymentInchargeId = selectedOption
//                               ? selectedOption.value
//                               : '';
//                             form.setFieldValue(
//                               'primaryDeploymentInchargeId',
//                               selectedPrimaryDeploymentInchargeId
//                             );
//                             const selectedIncharge = primaryDeploymentIncharges.find(
//                               (incharge) =>
//                                 incharge.primaryDeploymentInchargeId ===
//                                 Number(selectedPrimaryDeploymentInchargeId)
//                             );
//                             if (selectedIncharge) {
//                               setFieldValue(
//                                 'PrimaryDeploymentInchargeName',
//                                 selectedIncharge.primaryDeploymentInchargeName
//                               );
//                               setFieldValue(
//                                 'PrimaryDeploymentInchargeNumber',
//                                 selectedIncharge.mobileNumber
//                               );
//                               setFieldTouched('primaryDeploymentInchargeId', false);
//                               setFieldError('primaryDeploymentInchargeId', '');
//                             } else {
//                               setFieldValue('PrimaryDeploymentInchargeName', '');
//                               setFieldValue('PrimaryDeploymentInchargeNumber', '');
//                             }
//                           }}
//                           onBlur={() =>
//                             setFieldTouched('primaryDeploymentInchargeId', true)
//                           }
//                           isClearable={true}
//                           isSearchable={true}
//                         />
//                       )}
//                     </Field>
//                     <ErrorMessage
//                       className="form-text text-danger"
//                       name="primaryDeploymentInchargeId"
//                       component="span"
//                     />
//                   </div>
//                 </div>
//               )}
//               {Number(values.collectionTypeId) === 2 && (
//                 <div className="col-md-4">
//                   <div
//                     className="form-group"
//                     title={`${values.SecondaryDeploymentInchargeName} ${values.SecondaryDeploymentInchargeNumber}`}
//                   >
//                     <label className="form-label">Secondary Incharge</label>
//                     <Field name="secondaryDeploymentInchargeId">
//                       {({ field, form }) => (
//                         <Select
//                           {...field}
//                           options={secondaryDeploymentIncharges
//                             .filter((incharge) => incharge.isActive)
//                             .map((incharge) => ({
//                               value: incharge.secondaryDeploymentInchargeId,
//                               label: `${incharge.secondaryDeploymentInchargeName} [${incharge.mobileNumber}]`,
//                             }))}
//                           classNamePrefix="CreatableSelect"
//                           placeholder="Select"
//                           value={secondaryDeploymentIncharges
//                             .filter((incharge) => incharge.isActive)
//                             .map((incharge) => ({
//                               value: incharge.secondaryDeploymentInchargeId,
//                               label: `${incharge.secondaryDeploymentInchargeName} [${incharge.mobileNumber}]`,
//                             }))
//                             .find((option) => option.value === field.value)}
//                           onChange={(selectedOption) => {
//                             const selectedSecondaryDeploymentInchargeId = selectedOption
//                               ? selectedOption.value
//                               : '';
//                             form.setFieldValue(
//                               'secondaryDeploymentInchargeId',
//                               selectedSecondaryDeploymentInchargeId
//                             );
//                             const selectedIncharge = secondaryDeploymentIncharges.find(
//                               (incharge) =>
//                                 incharge.secondaryDeploymentInchargeId ===
//                                 Number(selectedSecondaryDeploymentInchargeId)
//                             );
//                             if (selectedIncharge) {
//                               form.setFieldValue(
//                                 'SecondaryDeploymentInchargeName',
//                                 selectedIncharge.secondaryDeploymentInchargeName
//                               );
//                               form.setFieldValue(
//                                 'SecondaryDeploymentInchargeNumber',
//                                 selectedIncharge.mobileNumber
//                               );
//                               form.setFieldTouched('secondaryDeploymentInchargeId', false);
//                               form.setFieldError('secondaryDeploymentInchargeId', '');
//                             } else {
//                               form.setFieldValue('SecondaryDeploymentInchargeName', '');
//                               form.setFieldValue('SecondaryDeploymentInchargeNumber', '');
//                             }
//                           }}
//                           onBlur={() =>
//                             form.setFieldTouched('secondaryDeploymentInchargeId', true)
//                           }
//                           isClearable={true}
//                           isSearchable={true}
//                         />
//                       )}
//                     </Field>
//                     <ErrorMessage
//                       className="form-text text-danger"
//                       name="secondaryDeploymentInchargeId"
//                       component="span"
//                     />
//                   </div>
//                 </div>
//               )}
//               <div className="col-md-4">
//                 <div className="form-group" title={values.transferStationName}>
//                   <label className="form-label">Transfer Station</label>
//                   <Field name="transferStationId">
//                     {({ field, form }) => (
//                       <Select
//                         {...field}
//                         options={transferStations
//                           .filter((station) => station.isActive)
//                           .map((station) => ({
//                             value: station.transferStationId,
//                             label: station.transferStationName,
//                           }))}
//                         classNamePrefix="CreatableSelect"
//                         placeholder="Select"
//                         value={transferStations
//                           .filter((station) => station.isActive)
//                           .map((station) => ({
//                             value: station.transferStationId,
//                             label: station.transferStationName,
//                           }))
//                           .find((option) => option.value === field.value)}
//                         onChange={(selectedOption) => {
//                           const selectedTransferStationId = selectedOption
//                             ? selectedOption.value
//                             : '';
//                           form.setFieldValue('transferStationId', selectedTransferStationId);
//                           const selectedStation = transferStations.find(
//                             (station) =>
//                               station.transferStationId ===
//                               Number(selectedTransferStationId)
//                           );
//                           if (selectedStation) {
//                             form.setFieldValue(
//                               'transferStationName',
//                               selectedStation.transferStationName
//                             );
//                             form.setFieldTouched('transferStationId', false);
//                             form.setFieldError('transferStationId', '');
//                           } else {
//                             form.setFieldValue('transferStationName', '');
//                           }
//                         }}
//                         onBlur={() => form.setFieldTouched('transferStationId', true)}
//                         isClearable={true}
//                         isSearchable={true}
//                       />
//                     )}
//                   </Field>
//                   <ErrorMessage
//                     className="form-text text-danger"
//                     name="transferStationId"
//                     component="span"
//                   />
//                 </div>
//               </div>
//               <div className="col-12">
//                 <h5>Trips</h5>
//                 {tripRows.length === 0 ? (
//                   <div className="mb-3">
//                     <button
//                       type="button"
//                       className="btn btn-primary"
//                       onClick={addTripRow}
//                     >
//                       <i className="fa-solid fa-plus"></i> Add Trip
//                     </button>
//                   </div>
//                 ) : (
//                   tripRows.map((row, index) => (
//                     <div key={row.id} className="mb-3">
//                       <h6>Trip - {index + 1}</h6>
//                       <div className="row align-items-center">
//                         <div className="col-md-3">
//                           <div className="form-group">
//                             <label className="form-label">Start Route Point</label>
//                             <Select
//                               options={getAvailableCollectionPoints(row.id, 'primary')}
//                               classNamePrefix="CreatableSelect"
//                               placeholder="Select Filter-1"
//                               value={getAvailableCollectionPoints(row.id, 'primary').find(
//                                 (option) => option.value === row.primaryCollectionPointId
//                               )}
//                               onChange={(selectedOption) => {
//                                 const newRows = [...tripRows];
//                                 newRows[index].primaryCollectionPointId = selectedOption
//                                   ? selectedOption.value
//                                   : '';
//                                 setTripRows(newRows);
//                               }}
//                               onBlur={() =>
//                                 setFieldTouched(`trips[${index}].primaryCollectionPointId`, true)
//                               }
//                               isClearable={true}
//                               isSearchable={true}
//                             />
//                           </div>
//                         </div>
//                         <div className="col-md-3">
//                           <div className="form-group">
//                             <label className="form-label">End Route Point</label>
//                             <Select
//                               options={getAvailableCollectionPoints(row.id, 'secondary')}
//                               classNamePrefix="CreatableSelect"
//                               placeholder="Select Filter-2"
//                               value={getAvailableCollectionPoints(row.id, 'secondary').find(
//                                 (option) => option.value === row.secondaryCollectionPointId
//                               )}
//                               onChange={(selectedOption) => {
//                                 const newRows = [...tripRows];
//                                 newRows[index].secondaryCollectionPointId = selectedOption
//                                   ? selectedOption.value
//                                   : '';
//                                 setTripRows(newRows);
//                               }}
//                               onBlur={() =>
//                                 setFieldTouched(
//                                   `trips[${index}].secondaryCollectionPointId`,
//                                   true
//                                 )
//                               }
//                               isClearable={true}
//                               isSearchable={true}
//                             />
//                           </div>
//                         </div>
//                         <div className="col-md-3">
//                           <div className="form-group">
//                             <label className="form-label">Shift</label>
//                             <div className="d-flex gap-3">
//                               {['A', 'B', 'C'].map((shift) => (
//                                 <div key={shift} className="form-check">
//                                   <input
//                                     type="checkbox"
//                                     className="form-check-input"
//                                     id={`shift-${row.id}-${shift}`}
//                                     checked={row.shifts.includes(shift)}
//                                     onChange={() => handleShiftChange(row.id, shift)}
//                                   />
//                                   <label
//                                     className="form-check-label"
//                                     htmlFor={`shift-${row.id}-${shift}`}
//                                   >
//                                     {shift}
//                                   </label>
//                                 </div>
//                               ))}
//                             </div>
//                           </div>
//                         </div>
//                         <div className="col-md-3 d-flex">
//                           {index === tripRows.length - 1 && (
//                             <button
//                               type="button"
//                               className="btn btn-primary me-2"
//                               onClick={addTripRow}
//                             >
//                               <i className="fa-solid fa-plus"></i>
//                             </button>
//                           )}
//                           {tripRows.length > 1 && (
//                             <button
//                               type="button"
//                               className="btn btn-danger"
//                               onClick={() => removeTripRow(row.id)}
//                             >
//                               <i className="fa-solid fa-trash"></i>
//                             </button>
//                           )}
//                         </div>
//                       </div>
//                     </div>
//                   ))
//                 )}
//               </div>
//               <div className="col-12">
//                 <div className="row">
//                   <div className="col-md-4">
//                     <div className="form-group">
//                       <label htmlFor="vehicleImageUrl" className="form-label">
//                         Vehicle Insurance
//                       </label>
//                       <input
//                         type="file"
//                         id="vehicleImageUrl"
//                         name="vehicleImageUrl"
//                         accept=".png, .jpg, .jpeg"
//                         onChange={(e) => {
//                           handleFileChange(e, 'vehicleImageUrl');
//                           setFieldValue('vehicleImageUrl', e.currentTarget.files[0]);
//                         }}
//                         className="form-control"
//                       />
//                       <ErrorMessage
//                         className="form-text text-danger"
//                         name="vehicleImageUrl"
//                         component="span"
//                       />
//                       {filePreviews.vehicleImageUrl?.fileUrl && (
//                         <FilePreview
//                           file={filePreviews.vehicleImageUrl.file}
//                           fileType={filePreviews.vehicleImageUrl.fileType}
//                           fileUrl={filePreviews.vehicleImageUrl.fileUrl}
//                         />
//                       )}
//                     </div>
//                   </div>
//                   <div className="col-md-4">
//                     <div className="form-group">
//                       <label htmlFor="rcimageUrl" className="form-label">
//                         Registration Certificate
//                       </label>
//                       <input
//                         type="file"
//                         id="rcimageUrl"
//                         name="rcimageUrl"
//                         accept="image/png, image/jpeg, image/jpg"
//                         onChange={(e) => {
//                           handleFileChange(e, 'rcimageUrl');
//                           setFieldValue('rcimageUrl', e.currentTarget.files[0]);
//                         }}
//                         className="form-control"
//                       />
//                       <ErrorMessage
//                         className="form-text text-danger"
//                         name="rcimageUrl"
//                         component="span"
//                       />
//                       {filePreviews.rcimageUrl?.fileUrl && (
//                         <FilePreview
//                           file={filePreviews.rcimageUrl.file}
//                           fileType={filePreviews.rcimageUrl.fileType}
//                           fileUrl={filePreviews.rcimageUrl.fileUrl}
//                         />
//                       )}
//                     </div>
//                   </div>
//                   <div className="col-md-4">
//                     <div className="form-group">
//                       <label htmlFor="pcimageUrl" className="form-label">
//                         Pollution Certificate
//                       </label>
//                       <input
//                         type="file"
//                         id="pcimageUrl"
//                         name="pcimageUrl"
//                         accept=".png, .jpg, .jpeg"
//                         onChange={(e) => {
//                           handleFileChange(e, 'pcimageUrl');
//                           setFieldValue('pcimageUrl', e.currentTarget.files[0]);
//                         }}
//                         className="form-control"
//                       />
//                       <ErrorMessage
//                         className="form-text text-danger"
//                         name="pcimageUrl"
//                         component="span"
//                       />
//                       {filePreviews.pcimageUrl?.fileUrl && (
//                         <FilePreview
//                           file={filePreviews.pcimageUrl.file}
//                           fileType={filePreviews.pcimageUrl.fileType}
//                           fileUrl={filePreviews.pcimageUrl.fileUrl}
//                         />
//                       )}
//                     </div>
//                   </div>
//                 </div>
//               </div>
//               <BaseFormComponent
//                 label="Vehicle Brand Name"
//                 name="vehicleBrandName"
//                 type="text"
//                 placeholder="Enter Vehicle Brand Name"
//                 max="42"
//                 handleSpecialCharacters={handleSpecialCharacters}
//               />
//               <BaseFormComponent
//                 label="Contractor Name"
//                 name="contractorName"
//                 type="text"
//                 placeholder="Enter Contractor Name"
//                 max="42"
//                 handleSpecialCharacters={handleSpecialCharacters}
//               />
//               <BaseFormComponent
//                 label="RFID"
//                 name="RFID"
//                 type="text"
//                 placeholder="Enter RFID"
//                 max="12"
//                 handleSpecialCharacters={handleSpecialCharacters}
//               />
//               <div className="col-md-12 mb-3">
//                 <div className="form-group">
//                   <label htmlFor="remark" className="form-label">
//                     Remarks
//                   </label>
//                   <Field
//                     as="textarea"
//                     id="remark"
//                     name="remark"
//                     className="form-control"
//                     maxLength="500"
//                     rows="3"
//                   />
//                   <ErrorMessage
//                     className="form-text text-danger"
//                     name="remark"
//                     component="span"
//                   />
//                 </div>
//               </div>
//               <div className="row" style={{ marginTop: '5px' }}>
//                 <div className="col-md-4">
//                   <label className="form-label">
//                     Status <span style={{ color: '#EC1117' }}>*</span>
//                   </label>
//                   <div className="d-flex gap-4">
//                     <div className="form-group d-flex justify-content-center align-items-center gap-2">
//                       <div className="radio-button-group">
//                         <Field name="isActive">
//                           {({ field }) => (
//                             <input
//                               type="radio"
//                               id="active"
//                               {...field}
//                               value={true}
//                               checked={values.isActive === true}
//                               onChange={() => setFieldValue('isActive', true)}
//                             />
//                           )}
//                         </Field>
//                       </div>
//                       <label htmlFor="active">Active</label>
//                     </div>
//                     <div className="form-group d-flex justify-content-center align-items-center gap-2">
//                       <div className="radio-button-group">
//                         <Field name="isActive">
//                           {({ field }) => (
//                             <input
//                               type="radio"
//                               id="inactive"
//                               {...field}
//                               value={false}
//                               checked={values.isActive === false}
//                               onChange={() => setFieldValue('isActive', false)}
//                             />
//                           )}
//                         </Field>
//                       </div>
//                       <label htmlFor="inactive">Inactive</label>
//                     </div>
//                   </div>
//                   <ErrorMessage
//                     className="form-text text-danger"
//                     name="isActive"
//                     component="span"
//                   />
//                 </div>
//               </div>
//               <div className="modal-footer d-flex justify-content-center">
//                 {canWrite === true ? (
//                   <button
//                     type="submit"
//                     className="deployment-button"
//                     disabled={isSubmit}
//                   >
//                     {isSubmit ? (
//                       <l-waveform
//                         size="20"
//                         stroke="3.5"
//                         speed="1"
//                         color="black"
//                       ></l-waveform>
//                     ) : (
//                       <>
//                         <i className="fa-solid fa-check done-container"></i>
//                         {editVehicleData ? 'Update' : 'Save'}
//                       </>
//                     )}
//                   </button>
//                 ) : (
//                   ''
//                 )}
//               </div>
//             </div>
//           </Form>
//         )}
//       </Formik>
//     </div>
//   );
// };

// export default AddVehicleForm;









































































// // import React, { useEffect, useState } from "react";
// // import FileInput from "./form_fields/FileInput";
// // import RadioInput from "./form_fields/RadioInput";
// // import BaseFormComponent from "./form_fields/BaseFormComponent";
// // import SelectInput from "./form_fields/SelectInput";
// // import Select from 'react-select';
// // import * as Yup from "yup";
// // import { toast } from "react-toastify";
// // import { useDropdownStore } from "./store/useDropdownStore";
// // import { Formik, Form, ErrorMessage, Field } from "formik";
// // import FilePreview from "./FilePreview";
// // import { useVehicleStore } from "./store/useVehicleStore";
// // import getValidationSchema from "./getValidationSchema";
// // import { waveform } from "ldrs";
// // import { handleUuid } from "../../../utils/ValidationsHelper";
// // import { getWritePermission } from "./utils/helpers";
// // import RouteMastersStore from "../RouteMaster/store/useRouteMasterStore";

// // const AddVehicleForm = ({
// //   handleSearch,
// //   editVehicleData,
// //   setEditVehicleData,
// //   handleClose,
// // }) => {
// //   const {
// //     fuelTypes,
// //     collectionTypes,
// //     vehicleTypes,
// //     ownerTypes,
// //     vehicleCapacities,
// //     zones,
// //     circles,
// //     wards,
// //     drivers,
// //     primaryDeploymentIncharges,
// //     secondaryDeploymentIncharges,
// //     transferStations,
// //     loading,
// //     vehicleStatus,
// //     fileInputs,
// //     filePreviews,
// //     resetFileInputs,
// //     fetchVehicleTypes,
// //     fetchOwnerTypes,
// //     fetchVehicleCapacities,
// //     fetchVehicleStatus,
// //     fetchFuelTypes,
// //     fetchCollectionTypes,
// //     fetchZones,
// //     fetchCircles,
// //     fetchWards,
// //     fetchDrivers,
// //     fetchPrimaryDeploymentIncharges,
// //     fetchSecondaryDeploymentIncharges,
// //     fetchTransferStations,
// //     handleFileChange,
// //     updateFilePreview,
// //     fetchAllVehicleCategories,
// //     vehicleCategoryData,
// //     fetchAllRouteStartAndEndPoints,
// //     routestartAndEndPointsData,
// //   } = useDropdownStore();
// //   const { fetchRouteMasters, routeMasterData } = RouteMastersStore()
// //   const canWrite = getWritePermission();
// //   const {
// //     saveVehicleDetails,
// //   } = useVehicleStore();

// //   useEffect(() => {
// //     fetchFuelTypes();
// //     fetchCollectionTypes();
// //     fetchVehicleStatus();
// //     fetchOwnerTypes();
// //     fetchZones();
// //     fetchDrivers();
// //     fetchPrimaryDeploymentIncharges();
// //     fetchSecondaryDeploymentIncharges();
// //     fetchTransferStations();
// //     fetchAllVehicleCategories();
// //     if (editVehicleData) {
// //       fetchVehicleTypes(editVehicleData?.collectionTypeId);
// //       fetchVehicleCapacities(editVehicleData?.vehicleTypeId);
// //       fetchCircles(editVehicleData?.zoneId);
// //       fetchWards(editVehicleData?.circleId);
// //       fetchDrivers(editVehicleData?.collectionTypeId);
// //       updateFilePreview(
// //         editVehicleData?.vehicleImageUrl ?? null,
// //         editVehicleData?.rcimageUrl ?? null,
// //         editVehicleData?.pcimageUrl ?? null
// //       );
// //     }
// //   }, [editVehicleData]);

// //   // const getValidationSchema = (collectionTypeId, isEditMode) => {
// //   //   return Yup.object().shape({
// //   //     zoneId: Yup.string().required("Zone is required"),
// //   //     circleId:
// //   //       [1, 2].includes(Number(collectionTypeId))
// //   //         ? Yup.string().required("Circle is required")
// //   //         : Yup.string(),
// //   //   wardId: isEditMode
// //   //     ? Yup.string().required("Ward is required when updating")
// //   //     : Yup.string(),
// //   // });
// //   // };

// //   const initialVehicleDetails = {
// //     vehicleNumber: editVehicleData?.vehicleNumber || "",
// //     chassisNumber: editVehicleData?.chassisNumber || "",
// //     fuelTypeId: editVehicleData?.fuelTypeId || "",
// //     collectionTypeId: editVehicleData?.collectionTypeId || "",
// //     vehicleTypeId: editVehicleData?.vehicleTypeId || "",
// //     vehicleCapacityId: editVehicleData?.vehicleCapacityId || "",
// //     vehicleStatusId: editVehicleData?.vehicleStatusId || "",
// //     ownerTypeId: editVehicleData?.ownerTypeId || "",
// //     vehicleUuid: editVehicleData?.vehicleUuid || "",
// //     zoneId: editVehicleData?.zoneId || "",
// //     circleId: editVehicleData?.circleId || "",
// //     // wardId: editVehicleData?.wardId || "",
// //     driverId: editVehicleData?.driverId || "",
// //     RFID: editVehicleData?.rfid || "",
// //     primaryDeploymentInchargeId:
// //       editVehicleData?.primaryDeploymentInchargeId || "",
// //     secondaryDeploymentInchargeId:
// //       editVehicleData?.secondaryDeploymentInchargeId || "",
// //     transferStationId: editVehicleData?.transferStationId || "",
// //     vehicleImageUrl: null,
// //     rcimageUrl: null,
// //     pcimageUrl: null,
// //     vehicleBrandName: editVehicleData?.vehicleBrandName || "",
// //     contractorName: editVehicleData?.contractorName || "",
// //     remark: editVehicleData?.remark || "",
// //     isActive: editVehicleData?.isActive || true,
// //     //
// //     fuelTypeName: editVehicleData?.fuelTypeName || "",
// //     collectionTypeName: editVehicleData?.collectionTypeName || "",
// //     vehicleCategoryId: editVehicleData?.vehicleCategoryId || "",
// //     ownerTypeName: editVehicleData?.ownerTypeName || "",
// //     transferStationName: editVehicleData?.transferStationName || "",

// //     vehicleTypeName: editVehicleData?.vehicleTypeName || "",
// //     vehicleCapacityName: editVehicleData?.vehicleCapacityName || "",
// //     vehicleStatusName: editVehicleData?.vehicleStatusName || "",

// //     DriverNumber: editVehicleData?.driverNumber || "",
// //     DriverName: editVehicleData?.driverName || "",

// //     PrimaryDeploymentInchargeName:
// //       editVehicleData?.primaryDeploymentInchargeName || "",
// //     PrimaryDeploymentInchargeNumber:
// //       editVehicleData?.primaryDeploymentInchargeNumber || "",

// //     SecondaryDeploymentInchargeNumber:
// //       editVehicleData?.SecondaryDeploymentInchargeNumber || "",
// //     SecondaryDeploymentInchargeName:
// //       editVehicleData?.secondaryDeploymentInchargeName || "",
// //     //
// //     ...(editVehicleData?.vehicleId && { vehicleId: editVehicleData.vehicleId }),
// //   };

// //   const [collectionTypeId, setCollectionTypeId] = useState(
// //     initialVehicleDetails.collectionTypeId
// //   );
// //   const [isSubmit, setIsSubmit] = useState(false);
// //   waveform.register();

// //   const handleSubmit = async (values, resetForm, setErrors) => {
// //     // console.log("Form Submitted Values:", values);
// //     // console.log("Uploaded Files:", fileInputs);
// //     setIsSubmit(true);
// //     const formattedValues = {
// //       ...values,
// //       wardId: values.wardId ? values.wardId : undefined,
// //       PrimaryDeploymentInchargeName:
// //         values.collectionTypeId === "2" ? "" : values.PrimaryDeploymentInchargeName,
// //       PrimaryDeploymentInchargeNumber:
// //         values.collectionTypeId === "2" ? "" : values.PrimaryDeploymentInchargeNumber,
// //       SecondaryDeploymentInchargeNumber:
// //         values.collectionTypeId === "1" ? "" : values.SecondaryDeploymentInchargeNumber,
// //       SecondaryDeploymentInchargeName:
// //         values.collectionTypeId === "1" ? "" : values.SecondaryDeploymentInchargeName,
// //     };
// //     try {
// //       const response = await saveVehicleDetails(formattedValues, editVehicleData);
// //       handleSearch();
// //       toast.success(
// //         editVehicleData
// //           ? "Vehicle updated successfully"
// //           : "New Vehicle added successfully"
// //       );
// //       setEditVehicleData(null);
// //       handleClose();
// //       resetFileInputs();
// //       setIsSubmit(false);
// //     } catch (xhr) {
// //       console.log("xhr.errors:", xhr);
// //       if (xhr && xhr.response && typeof xhr.response.data.errors === "object") {
// //         const formErrors = {};
// //         Object.keys(xhr.response.data.errors).forEach((key) => {
// //           if (
// //             Array.isArray(xhr.response.data.errors[key]) &&
// //             xhr.response.data.errors[key].length > 0
// //           ) {
// //             formErrors[key] = xhr.response.data.errors[key][0];
// //             console.log(`${key}: ${xhr.response.data.errors[key][0]}`);
// //             toast.error(`${key}: ${xhr.response.data.errors[key][0]}`);
// //           }
// //         });
// //       } else {
// //         toast.error(xhr.response.data);
// //       }
// //       setIsSubmit(false);
// //     }
// //     resetForm();
// //   };

// //   const handleSpecialCharacters = (e) => {
// //     const value = e.target.value;

// //     // Allow only alphanumeric characters and single spaces between words
// //     const sanitizedValue = value
// //       .replace(/[^a-zA-Z0-9\s]/g, "") // Remove special characters except spaces
// //       .replace(/^\s+/, "") // Remove leading spaces
// //       .replace(/\s{2,}/g, " "); // Replace multiple spaces with a single space

// //     e.target.value = sanitizedValue;
// //   };


// //   return (
// //     <div>
// //       <Formik
// //         initialValues={initialVehicleDetails}
// //         validationSchema={getValidationSchema(collectionTypeId, editVehicleData)}
// //         onSubmit={handleSubmit}
// //         validateOnChange={true}
// //         validateOnBlur={true}
// //       >
// //         {({
// //           values,
// //           setFieldValue,
// //           setFieldError,
// //           resetForm,
// //           setFieldTouched,
// //           setErrors,
// //           setTouched,
// //         }) => (
// //           <Form>
// //             <div className="row">
// //               {/* Vehicle Number */}
// //               <BaseFormComponent
// //                 label="Vehicle Number"
// //                 name="vehicleNumber"
// //                 type="text"
// //                 // max="12"
// //                 placeholder="Enter Vehicle Registration Number"
// //                 required
// //               />
// //               {/* Vehicle Chassis Number */}
// //               <BaseFormComponent
// //                 label="Vehicle Chassis Number"
// //                 name="chassisNumber"
// //                 type="text"
// //                 max="30"
// //                 handleSpecialCharacters={handleSpecialCharacters}
// //                 placeholder="Enter Vehicle Chassis Number"
// //               // required
// //               />
// //               {/* Fuel Type */}
// //               <div className="col-md-4">
// //                 <div className="form-group">
// //                   <label className="form-label">
// //                     Fuel Type
// //                     <span style={{ color: "#EC1117" }}> *</span>
// //                   </label>
// //                   <Field
// //                     as="select"
// //                     name="fuelTypeId"
// //                     className="form-select"
// //                     onChange={(e) => {
// //                       const selectedFuelTypeId = e.target.value;
// //                       setFieldValue("fuelTypeId", selectedFuelTypeId);
// //                       setFieldTouched("fuelTypeId", false); // Mark field as not touched
// //                       setFieldError("fuelTypeId", ""); // Clear error message

// //                       const selectedFuelType = fuelTypes.find(
// //                         (fuelType) =>
// //                           fuelType.fuelTypeId === Number(selectedFuelTypeId)
// //                       );

// //                       if (selectedFuelType) {
// //                         setFieldValue(
// //                           "fuelTypeName",
// //                           selectedFuelType.fuelTypeName
// //                         );
// //                       }
// //                     }}
// //                   >
// //                     <option value="">Select</option>
// //                     {fuelTypes.map((fuelType) => (
// //                       <option
// //                         key={fuelType.fuelTypeId}
// //                         value={fuelType.fuelTypeId}
// //                       >
// //                         {fuelType.fuelTypeName}
// //                       </option>
// //                     ))}
// //                   </Field>
// //                   <ErrorMessage
// //                     className="form-text text-danger"
// //                     name="fuelTypeId"
// //                     component="span"
// //                   />
// //                 </div>
// //               </div>
// //               {/* Collection Type */}
// //               <div className="col-md-4">
// //                 <div className="form-group">
// //                   <label className="form-label">
// //                     Collection Type
// //                     <span style={{ color: "#EC1117" }}> *</span>
// //                   </label>
// //                   <Field
// //                     as="select"
// //                     name="collectionTypeId"
// //                     className="form-select"
// //                     onChange={(e) => {
// //                       const selectedValue = e.target.value;
// //                       const previousValue = values.collectionTypeId;

// //                       setFieldValue("collectionTypeId", selectedValue);
// //                       setFieldTouched("collectionTypeId", false); // Mark field as not touched
// //                       setFieldError("collectionTypeId", ""); // Clear error message

// //                       if (previousValue === "1" && selectedValue !== "1") {
// //                         setFieldValue("driverId", "");
// //                         setFieldTouched("driverId", false);
// //                         setFieldError("driverId", "");
// //                       }
// //                       if (selectedValue) {
// //                         setCollectionTypeId(selectedValue);
// //                         fetchVehicleTypes(selectedValue);
// //                         fetchDrivers(selectedValue);

// //                         if (selectedValue === "1") {
// //                           fetchPrimaryDeploymentIncharges();
// //                         } else if (selectedValue === "2") {
// //                           fetchSecondaryDeploymentIncharges();
// //                         }
// //                       }

// //                       // Find the selected collection type name and set it
// //                       const selectedCollectionType = collectionTypes.find(
// //                         (collectionType) =>
// //                           collectionType.collectionTypeId === Number(selectedValue)
// //                       );

// //                       if (selectedCollectionType) {
// //                         setFieldValue("collectionTypeName", selectedCollectionType.collectionTypeName);
// //                       }
// //                     }}
// //                   >

// //                     <option value="">Select</option>
// //                     {collectionTypes.map((collectionType) => (
// //                       <option
// //                         key={collectionType.collectionTypeId}
// //                         value={collectionType.collectionTypeId}
// //                       >
// //                         {collectionType.collectionTypeName}
// //                       </option>
// //                     ))}
// //                   </Field>
// //                   <ErrorMessage
// //                     className="form-text text-danger"
// //                     name="collectionTypeId"
// //                     component="span"
// //                   />
// //                 </div>
// //               </div>
// //               {/* Vehicle Type */}
// //               <div className="col-md-4">
// //                 <div className="form-group">
// //                   <label className="form-label">
// //                     Vehicle Type
// //                     <span style={{ color: "#EC1117" }}> *</span>
// //                   </label>
// //                   <Field
// //                     as="select"
// //                     name="vehicleTypeId"
// //                     className="form-select"
// //                     onChange={(e) => {
// //                       setFieldValue("vehicleTypeId", e.target.value);
// //                       setFieldTouched("vehicleTypeId", false); // Mark field as not touched
// //                       setFieldError("vehicleTypeId", ""); // Clear error message
// //                       if (e.target.value) {
// //                         fetchVehicleCapacities(e.target.value);
// //                       }

// //                       const selectedVehicleTypeId = e.target.value;
// //                       const selectedVehicleType = vehicleTypes.find(
// //                         (vehicleType) =>
// //                           vehicleType.vehicleTypeId ===
// //                           Number(selectedVehicleTypeId)
// //                       );

// //                       if (selectedVehicleType) {
// //                         setFieldValue(
// //                           "vehicleTypeName",
// //                           selectedVehicleType.vehicleTypeName
// //                         );
// //                       }
// //                     }}
// //                   >
// //                     <option value="">Select</option>
// //                     {vehicleTypes
// //                       .filter((vehicleType) => vehicleType.isActive)
// //                       .map((vehicleType) => (
// //                         <option
// //                           key={vehicleType.vehicleTypeId}
// //                           value={vehicleType.vehicleTypeId}
// //                         >
// //                           {vehicleType.vehicleTypeName}
// //                         </option>
// //                       ))}
// //                   </Field>
// //                   <ErrorMessage
// //                     className="form-text text-danger"
// //                     name="vehicleTypeId"
// //                     component="span"
// //                   />
// //                 </div>
// //               </div>
// //               {/* Vehicle Capacity */}
// //               <div className="col-md-4">
// //                 <div className="form-group">
// //                   <label className="form-label">
// //                     Vehicle Capacity
// //                     <span style={{ color: "#EC1117" }}> *</span>
// //                   </label>
// //                   <Field
// //                     as="select"
// //                     name="vehicleCapacityId"
// //                     className="form-select"
// //                     onChange={(e) => {
// //                       const selectedVehicleCapacityId = e.target.value;
// //                       setFieldValue("vehicleCapacityId", e.target.value);
// //                       setFieldTouched("vehicleCapacityId", false); // Mark field as not touched
// //                       setFieldError("vehicleCapacityId", ""); // Clear error message
// //                       const selectedVehicleCapacity = vehicleCapacities.find(
// //                         (vehicleCapacity) =>
// //                           vehicleCapacity.vehicleCapacityId ===
// //                           Number(selectedVehicleCapacityId)
// //                       );

// //                       if (selectedVehicleCapacity) {
// //                         setFieldValue(
// //                           "vehicleCapacityName",
// //                           selectedVehicleCapacity.vehicleCapacityName
// //                         );
// //                       }
// //                     }}
// //                   >
// //                     <option value="">Select</option>
// //                     {vehicleCapacities
// //                       .filter((vehicleCapacity) => vehicleCapacity.isActive)
// //                       .map((vehicleCapacity) => (
// //                         <option
// //                           key={vehicleCapacity.vehicleCapacityId}
// //                           value={vehicleCapacity.vehicleCapacityId}
// //                         >
// //                           {vehicleCapacity.vehicleCapacityName}
// //                         </option>
// //                       ))}
// //                   </Field>
// //                   <ErrorMessage
// //                     className="form-text text-danger"
// //                     name="vehicleCapacityId"
// //                     component="span"
// //                   />
// //                 </div>
// //               </div>
// //               {/* Vehicle Status */}
// //               <div className="col-md-4">
// //                 <div className="form-group">
// //                   <label className="form-label">
// //                     Vehicle Status
// //                     <span style={{ color: "#EC1117" }}> *</span>
// //                   </label>
// //                   <Field
// //                     as="select"
// //                     name="vehicleStatusId"
// //                     className="form-select"
// //                     onChange={(e) => {
// //                       const selectedVehicleStatusId = e.target.value;
// //                       setFieldValue("vehicleStatusId", e.target.value);
// //                       setFieldTouched("vehicleStatusId", false); // Mark field as not touched
// //                       setFieldError("vehicleStatusId", ""); // Clear error message
// //                       const selectedVehicleStatus = vehicleStatus.find(
// //                         (vehicleStatus) =>
// //                           vehicleStatus.vehicleStatusId ===
// //                           Number(selectedVehicleStatusId)
// //                       );
// //                       Number(selectedVehicleStatusId) === 2
// //                         ? setFieldValue("isActive", false)
// //                         : setFieldValue("isActive", true);

// //                       setFieldValue(
// //                         "vehicleStatusName",
// //                         selectedVehicleStatus?.vehicleStatusName
// //                       );
// //                     }}
// //                   >
// //                     <option value="">Select</option>
// //                     {vehicleStatus.map((status) => (
// //                       <option
// //                         key={status.vehicleStatusId}
// //                         value={status.vehicleStatusId}
// //                       >
// //                         {status.vehicleStatusName}
// //                       </option>
// //                     ))}
// //                   </Field>
// //                   <ErrorMessage
// //                     className="form-text text-danger"
// //                     name="vehicleStatusId"
// //                     component="span"
// //                   />
// //                 </div>
// //               </div>
// //               {/* Owner Type */}
// //               <div className="col-md-4">
// //                 <div className="form-group">
// //                   <label className="form-label">
// //                     Owner Type
// //                     <span style={{ color: "#EC1117" }}> *</span>
// //                   </label>
// //                   <Field
// //                     as="select"
// //                     name="ownerTypeId"
// //                     className="form-select"
// //                     onChange={(e) => {
// //                       const selectedOwnerTypeId = e.target.value;
// //                       setFieldValue("ownerTypeId", e.target.value);
// //                       setFieldTouched("ownerTypeId", false); // Mark field as not touched
// //                       setFieldError("ownerTypeId", ""); // Clear error message
// //                       const selectedOwnerType = ownerTypes.find(
// //                         (ownerType) =>
// //                           ownerType.ownerTypeId === Number(selectedOwnerTypeId)
// //                       );

// //                       if (selectedOwnerType) {
// //                         setFieldValue(
// //                           "ownerTypeName",
// //                           selectedOwnerType.ownerTypeName
// //                         );
// //                       }
// //                     }}
// //                   >
// //                     <option value="">Select</option>
// //                     {ownerTypes
// //                       .filter((owner) => owner.isActive)
// //                       .map((owner) => (
// //                         <option key={owner.ownerTypeId} value={owner.ownerTypeId}>
// //                           {owner.ownerTypeName}
// //                         </option>
// //                       ))}
// //                   </Field>
// //                   <ErrorMessage
// //                     className="form-text text-danger"
// //                     name="ownerTypeId"
// //                     component="span"
// //                   />
// //                 </div>
// //               </div>

// //               <div className="col-md-4">
// //                 <div className="form-group">
// //                   <label className="form-label">
// //                     Vehicle UID
// //                     <span style={{ color: "#EC1117" }}> *</span>
// //                   </label>
// //                   <Field
// //                     type="text"
// //                     id="vehicleUuid"
// //                     maxLength="20"
// //                     name="vehicleUuid"
// //                     onInput={handleUuid}
// //                     className="form-control"
// //                     placeholder="Enter Vehicle UID"
// //                   />
// //                   <ErrorMessage
// //                     className="form-text text-danger"
// //                     name="vehicleUuid"
// //                     component="span"
// //                   />
// //                 </div>
// //               </div>
// //               {/* Zone */}
// //               <div className="col-md-4">
// //                 <div className="form-group">
// //                   <label className="form-label">
// //                     Zone
// //                     <span style={{ color: "#EC1117" }}> *</span>
// //                   </label>
// //                   <Field
// //                     as="select"
// //                     name="zoneId"
// //                     className="form-select"
// //                     onChange={(e) => {
// //                       setFieldValue("zoneId", e.target.value);
// //                       setFieldValue("circleId", "");
// //                       setFieldValue("wardId", "");
// //                       setFieldTouched("zoneId", false); // Mark field as not touched
// //                       setFieldError("zoneId", ""); // Clear error message
// //                       if (e.target.value) {
// //                         fetchCircles(e.target.value);
// //                         fetchWards(e.target.value)
// //                       } else {
// //                         fetchCircles([]);

// //                         fetchWards([]);
// //                       }
// //                     }}
// //                   >
// //                     <option value="">Select</option>
// //                     {zones
// //                       .filter((zone) => zone.isActive)
// //                       .map((zone) => (
// //                         <option key={zone.zoneId} value={zone.zoneId}>
// //                           {zone.zoneName}
// //                         </option>
// //                       ))}
// //                   </Field>
// //                   <ErrorMessage
// //                     className="form-text text-danger"
// //                     name="zoneId"
// //                     component="span"
// //                   />
// //                 </div>
// //               </div>
// //               {/* Circle */}
// //               <div className="col-md-4">
// //                 <div className="form-group">
// //                   <label className="form-label">
// //                     Ward
// //                     {[1, 2].includes(Number(values.collectionTypeId)) && (
// //                       <span style={{ color: "#EC1117" }}> *</span>
// //                     )}
// //                   </label>
// //                   <Field
// //                     as="select"
// //                     name="circleId"
// //                     className="form-select"
// //                     onChange={(e) => {
// //                       setFieldValue("circleId", e.target.value);
// //                       setFieldValue("wardId", "");
// //                       setFieldTouched("circleId", false); // Mark field as not touched
// //                       setFieldError("circleId", ""); // Clear error message
// //                       if (e.target.value) {
// //                         fetchWards(e.target.value);
// //                       } else {
// //                         fetchWards([]);
// //                       }
// //                     }}
// //                   // disabled={circles.length === 0}
// //                   >
// //                     <option value="">Select</option>
// //                     {Array.isArray(circles) && circles.length > 0 ? (
// //                       circles.map((circle) => (
// //                         <option key={circle.circleId} value={circle.circleId}>
// //                           {circle.circleName}
// //                         </option>
// //                       ))
// //                     ) : (
// //                       <option value="" disabled>
// //                         No Wards found
// //                       </option>
// //                     )}
// //                   </Field>
// //                   <ErrorMessage
// //                     className="form-text text-danger"
// //                     name="circleId"
// //                     component="span"
// //                   />
// //                 </div>
// //               </div>
// //               {/* Ward */}
// //               {/* <div className="col-md-4">
// //                 <div className="form-group">
// //                   <label className="form-label">
// //                     Ward
// //                     {[1].includes(Number(values.collectionTypeId)) && (
// //                       <span style={{ color: "#EC1117" }}> *</span>
// //                     )}
// //                   </label>
// //                   <Field as="select" name="wardId" className="form-select" disabled={!wards.length}>
// //                     <option value="">Select</option>
// //                     {Array.isArray(wards) && wards.length > 0 ? (
// //                       wards
// //                         .filter((ward) => ward.isActive)
// //                         .map((ward) => (
// //                           <option key={ward.wardId} value={ward.wardId}>
// //                             {ward.wardName}
// //                           </option>
// //                         ))
// //                     ) : (
// //                       <option value="" disabled>
// //                         No Wards found
// //                       </option>
// //                     )
// //                     }
// //                   </Field>
// //                   <ErrorMessage
// //                     className="form-text text-danger"
// //                     name="wardId"
// //                     component="span"
// //                   />
// //                 </div>
// //               </div> */}
// //               {/* Driver Selection */}
// //               <div className="col-md-4">
// //                 <div className="form-group" title={values.DriverName + " " + values.DriverNumber}>
// //                   <label className="form-label">
// //                     Driver Name
// //                     {[1].includes(Number(values.collectionTypeId)) && (
// //                       <span style={{ color: "#EC1117" }}> *</span>
// //                     )}
// //                   </label>
// //                   <Field name="driverId">
// //                     {({ field, form }) => (
// //                       <Select
// //                         {...field}
// //                         options={drivers
// //                           .filter((driver) => driver.isActive)
// //                           .map((driver) => ({
// //                             value: driver.driverId,
// //                             label: `${driver.driverName} [${driver.mobileNumber}]`,
// //                           }))}
// //                         classNamePrefix="CreatableSelect"
// //                         placeholder="Select"
// //                         value={drivers
// //                           .filter((driver) => driver.isActive)
// //                           .map((driver) => ({
// //                             value: driver.driverId,
// //                             label: `${driver.driverName} [${driver.mobileNumber}]`,
// //                           }))
// //                           .find((option) => option.value === field.value)}
// //                         onChange={(selectedOption) => {
// //                           const selectedDriverId = selectedOption ? selectedOption.value : '';
// //                           form.setFieldValue('driverId', selectedDriverId);
// //                           const selectedDriver = drivers.find(
// //                             (driver) => driver.driverId === Number(selectedDriverId)
// //                           );
// //                           if (selectedDriver) {
// //                             setFieldValue('DriverName', selectedDriver.driverName);
// //                             setFieldValue('DriverNumber', selectedDriver.mobileNumber);
// //                             setFieldTouched('driverId', false);
// //                             setFieldError('driverId', '');
// //                           } else {
// //                             setFieldValue('DriverName', '');
// //                             setFieldValue('DriverNumber', '');
// //                           }
// //                         }}
// //                         onBlur={() => setFieldTouched('driverId', true)}
// //                         isClearable={true}
// //                         isSearchable={true}

// //                       />
// //                     )}
// //                   </Field>
// //                   <ErrorMessage
// //                     className="form-text text-danger"
// //                     name="driverId"
// //                     component="span"
// //                   />
// //                 </div>
// //               </div>

// //               {/* Deployment Incharge Selection */}
// //               {Number(values.collectionTypeId) === 1 && (
// //                 <div className="col-md-4">
// //                   <div className="form-group" title={values.PrimaryDeploymentInchargeName + " " + values.PrimaryDeploymentInchargeNumber}>
// //                     <label className="form-label">
// //                       SFA incharge
// //                       <span style={{ color: "#EC1117" }}> *</span>
// //                     </label>
// //                     <Field name="primaryDeploymentInchargeId">
// //                       {({ field, form }) => (
// //                         <Select
// //                           {...field}
// //                           options={primaryDeploymentIncharges
// //                             .filter((incharge) => incharge.isActive)
// //                             .map((incharge) => ({
// //                               value: incharge.primaryDeploymentInchargeId,
// //                               label: `${incharge.primaryDeploymentInchargeName} [${incharge.mobileNumber}]`,
// //                             }))}
// //                           // className="form-select"
// //                           classNamePrefix="CreatableSelect"
// //                           placeholder="Select"
// //                           value={primaryDeploymentIncharges
// //                             .filter((incharge) => incharge.isActive)
// //                             .map((incharge) => ({
// //                               value: incharge.primaryDeploymentInchargeId,
// //                               label: `${incharge.primaryDeploymentInchargeName} [${incharge.mobileNumber}]`,
// //                             }))
// //                             .find((option) => option.value === field.value)}
// //                           onChange={(selectedOption) => {
// //                             const selectedPrimaryDeploymentInchargeId = selectedOption ? selectedOption.value : '';
// //                             form.setFieldValue('primaryDeploymentInchargeId', selectedPrimaryDeploymentInchargeId);
// //                             const selectedIncharge = primaryDeploymentIncharges.find(
// //                               (incharge) => incharge.primaryDeploymentInchargeId === Number(selectedPrimaryDeploymentInchargeId)
// //                             );
// //                             if (selectedIncharge) {
// //                               setFieldValue('PrimaryDeploymentInchargeName', selectedIncharge.primaryDeploymentInchargeName);
// //                               setFieldValue('PrimaryDeploymentInchargeNumber', selectedIncharge.mobileNumber);
// //                               setFieldTouched('primaryDeploymentInchargeId', false);
// //                               setFieldError('primaryDeploymentInchargeId', '');
// //                             } else {
// //                               setFieldValue('PrimaryDeploymentInchargeName', '');
// //                               setFieldValue('PrimaryDeploymentInchargeNumber', '');
// //                             }
// //                           }}
// //                           onBlur={() => setFieldTouched('primaryDeploymentInchargeId', true)}
// //                           isClearable={true}
// //                           isSearchable={true}
// //                         />
// //                       )}
// //                     </Field>
// //                     <ErrorMessage
// //                       className="form-text text-danger"
// //                       name="primaryDeploymentInchargeId"
// //                       component="span"
// //                     />
// //                   </div>
// //                 </div>
// //               )}
// //               {/* Secondary Deployment Incharge */}
// //               {Number(values.collectionTypeId) === 2 && (
// //                 <div className="col-md-4">
// //                   <div className="form-group" title={values.SecondaryDeploymentInchargeName + " " + values.SecondaryDeploymentInchargeNumber}>
// //                     <label className="form-label">
// //                       Secondary Incharge
// //                     </label>
// //                     <Field name="secondaryDeploymentInchargeId">
// //                       {({ field, form }) => (
// //                         <Select
// //                           {...field}
// //                           options={secondaryDeploymentIncharges
// //                             .filter((incharge) => incharge.isActive)
// //                             .map((incharge) => ({
// //                               value: incharge.secondaryDeploymentInchargeId,
// //                               label: `${incharge.secondaryDeploymentInchargeName} [${incharge.mobileNumber}]`,
// //                             }))}
// //                           classNamePrefix="CreatableSelect"
// //                           placeholder="Select"
// //                           value={secondaryDeploymentIncharges
// //                             .filter((incharge) => incharge.isActive)
// //                             .map((incharge) => ({
// //                               value: incharge.secondaryDeploymentInchargeId,
// //                               label: `${incharge.secondaryDeploymentInchargeName} [${incharge.mobileNumber}]`,
// //                             }))
// //                             .find((option) => option.value === field.value)}
// //                           onChange={(selectedOption) => {
// //                             const selectedSecondaryDeploymentInchargeId = selectedOption ? selectedOption.value : '';
// //                             form.setFieldValue('secondaryDeploymentInchargeId', selectedSecondaryDeploymentInchargeId);
// //                             const selectedIncharge = secondaryDeploymentIncharges.find(
// //                               (incharge) => incharge.secondaryDeploymentInchargeId === Number(selectedSecondaryDeploymentInchargeId)
// //                             );
// //                             if (selectedIncharge) {
// //                               form.setFieldValue('SecondaryDeploymentInchargeName', selectedIncharge.secondaryDeploymentInchargeName);
// //                               form.setFieldValue('SecondaryDeploymentInchargeNumber', selectedIncharge.mobileNumber);
// //                               form.setFieldTouched('secondaryDeploymentInchargeId', false);
// //                               form.setFieldError('secondaryDeploymentInchargeId', '');
// //                             } else {
// //                               form.setFieldValue('SecondaryDeploymentInchargeName', '');
// //                               form.setFieldValue('SecondaryDeploymentInchargeNumber', '');
// //                             }
// //                           }}
// //                           onBlur={() => form.setFieldTouched('secondaryDeploymentInchargeId', true)}
// //                           isClearable={true}
// //                           isSearchable={true}
// //                         />
// //                       )}
// //                     </Field>



// //                     <ErrorMessage
// //                       className="form-text text-danger"
// //                       name="secondaryDeploymentInchargeId"
// //                       component="span"
// //                     />
// //                   </div>
// //                 </div>
// //               )}

// //               {/* Transfer Station Selection */}
// //               <div className="col-md-4">
// //                 <div className="form-group" title={values.transferStationName}>
// //                   <label className="form-label">
// //                     Transfer Station
// //                   </label>
// //                   <Field name="transferStationId">
// //                     {({ field, form }) => (
// //                       <Select
// //                         {...field}
// //                         options={transferStations
// //                           .filter((station) => station.isActive)
// //                           .map((station) => ({
// //                             value: station.transferStationId,
// //                             label: station.transferStationName,
// //                           }))}
// //                         classNamePrefix="CreatableSelect"
// //                         placeholder="Select"
// //                         value={transferStations
// //                           .filter((station) => station.isActive)
// //                           .map((station) => ({
// //                             value: station.transferStationId,
// //                             label: station.transferStationName,
// //                           }))
// //                           .find((option) => option.value === field.value)}
// //                         onChange={(selectedOption) => {
// //                           const selectedTransferStationId = selectedOption ? selectedOption.value : '';
// //                           form.setFieldValue('transferStationId', selectedTransferStationId);
// //                           const selectedStation = transferStations.find(
// //                             (station) => station.transferStationId === Number(selectedTransferStationId)
// //                           );
// //                           if (selectedStation) {
// //                             form.setFieldValue('transferStationName', selectedStation.transferStationName);
// //                             form.setFieldTouched('transferStationId', false);
// //                             form.setFieldError('transferStationId', '');
// //                           } else {
// //                             form.setFieldValue('transferStationName', '');
// //                           }
// //                         }}
// //                         onBlur={() => form.setFieldTouched('transferStationId', true)}
// //                         isClearable={true}
// //                         isSearchable={true}
// //                       />
// //                     )}
// //                   </Field>
// //                   <ErrorMessage
// //                     className="form-text text-danger"
// //                     name="transferStationId"
// //                     component="span"
// //                   />
// //                 </div>
// //               </div>
// //               {/* File Uploads */}
// //               {/* ******************************** */}

// //               <div className="col-md-4">
// //                 <div className="form-group">
// //                   <label className="form-label">Vehicle Category</label>
// //                   <Field as="select" name="vehicleCategoryId" className="form-select">
// //                     <option value="">Select</option>
// //                     {vehicleCategoryData
// //                       .map((item) => (
// //                         <option key={item.vehicleCategoryId} value={item.vehicleCategoryId}>
// //                           {item.vehicleCategoryName}
// //                         </option>
// //                       ))}
// //                   </Field>
// //                   <ErrorMessage
// //                     className="form-text text-danger"
// //                     name="vehicleCategoryId"
// //                     component="span"
// //                   />
// //                 </div>
// //               </div>


// //               <div className="col-12">
// //                 <div className="row">
// //                   <div className="col-md-4">
// //                     <div className="form-group">
// //                       <label htmlFor="vehicleImageUrl" className="form-label">
// //                         Vehicle Insurance
// //                       </label>
// //                       <input
// //                         type="file"
// //                         id="vehicleImageUrl"
// //                         name="vehicleImageUrl"
// //                         accept=".png, .jpg, .jpeg"
// //                         onChange={(e) => {
// //                           handleFileChange(e, "vehicleImageUrl");
// //                           setFieldValue(
// //                             "vehicleImageUrl",
// //                             e.currentTarget.files[0]
// //                           );
// //                         }}
// //                         className="form-control"
// //                       />
// //                       <ErrorMessage
// //                         className="form-text text-danger"
// //                         name="vehicleImageUrl"
// //                         component="span"
// //                       />
// //                       {filePreviews.vehicleImageUrl?.fileUrl && (
// //                         <FilePreview
// //                           file={filePreviews.vehicleImageUrl.file}
// //                           fileType={filePreviews.vehicleImageUrl.fileType}
// //                           fileUrl={filePreviews.vehicleImageUrl.fileUrl}
// //                         />
// //                       )}
// //                     </div>
// //                   </div>

// //                   <div className="col-md-4">
// //                     <div className="form-group">
// //                       <label htmlFor="rcimageUrl" className="form-label">
// //                         Registration Certificate
// //                       </label>
// //                       <input
// //                         type="file"
// //                         id="rcimageUrl"
// //                         name="rcimageUrl"
// //                         accept="image/png, image/jpeg ,image/jpg"
// //                         onChange={(e) => {
// //                           handleFileChange(e, "rcimageUrl");
// //                           setFieldValue("rcimageUrl", e.currentTarget.files[0]);
// //                         }}
// //                         className="form-control"
// //                       />
// //                       <ErrorMessage
// //                         className="form-text text-danger"
// //                         name="rcimageUrl"
// //                         component="span"
// //                       />
// //                       {filePreviews.rcimageUrl?.fileUrl && (
// //                         <FilePreview
// //                           file={filePreviews.rcimageUrl.file}
// //                           fileType={filePreviews.rcimageUrl.fileType}
// //                           fileUrl={filePreviews.rcimageUrl.fileUrl}
// //                         />
// //                       )}
// //                     </div>
// //                   </div>

// //                   <div className="col-md-4">
// //                     <div className="form-group">
// //                       <label htmlFor="pcimageUrl" className="form-label">
// //                         Pollution Certificate
// //                       </label>
// //                       <input
// //                         type="file"
// //                         id="pcimageUrl"
// //                         name="pcimageUrl"
// //                         accept=".png, .jpg, .jpeg"
// //                         onChange={(e) => {
// //                           handleFileChange(e, "pcimageUrl");
// //                           setFieldValue("pcimageUrl", e.currentTarget.files[0]);
// //                         }}
// //                         className="form-control"
// //                       />
// //                       <ErrorMessage
// //                         className="form-text text-danger"
// //                         name="pcimageUrl"
// //                         component="span"
// //                       />
// //                       {filePreviews.pcimageUrl?.fileUrl && (
// //                         <FilePreview
// //                           file={filePreviews.pcimageUrl.file}
// //                           fileType={filePreviews.pcimageUrl.fileType}
// //                           fileUrl={filePreviews.pcimageUrl.fileUrl}
// //                         />
// //                       )}
// //                     </div>
// //                   </div>
// //                 </div>
// //               </div>
// //               {/* ******************************** */}

// //               {/* Vehicle Brand Name */}
// //               <BaseFormComponent
// //                 label="Vehicle Brand Name"
// //                 name="vehicleBrandName"
// //                 type="text"
// //                 placeholder="Enter Vehicle Brand Name"
// //                 max="42"
// //                 handleSpecialCharacters={handleSpecialCharacters}
// //               />

// //               {/* Contractor Name */}
// //               <BaseFormComponent
// //                 label="Contractor Name"
// //                 name="contractorName"
// //                 type="text"
// //                 placeholder="Enter Contractor Name"
// //                 max="42"
// //                 handleSpecialCharacters={handleSpecialCharacters}
// //               />
// //               {/* RFID */}
// //               <BaseFormComponent
// //                 label="RFID"
// //                 name="RFID"
// //                 type="text"
// //                 placeholder="Enter RFID"
// //                 max="12"
// //                 handleSpecialCharacters={handleSpecialCharacters}
// //               />
// //               {/* Remarks */}
// //               <div className="col-md-12 mb-3">
// //                 <div className="form-group">
// //                   <label htmlFor="remark" className="form-label">
// //                     Remarks
// //                   </label>
// //                   <Field
// //                     as="textarea"
// //                     id="remark"
// //                     name="remark"
// //                     className="form-control"
// //                     maxLength="500"
// //                     rows="3"
// //                   />
// //                 </div>
// //                 <ErrorMessage
// //                   className="form-text text-danger"
// //                   name="remark"
// //                   component="span"
// //                 />
// //               </div>

// //               <div className="row" style={{ marginTop: "5px" }}>
// //                 <div className="col-md-4">
// //                   <label className="form-label">Status <span style={{ color: "#EC1117" }}> *</span></label>
// //                   <div className="d-flex gap-4">
// //                     <div className="form-group d-flex justify-content-center align-items-center gap-2">
// //                       <div className="radio-button-group">
// //                         <Field name="isActive">
// //                           {({ field }) => (
// //                             <input
// //                               type="radio"
// //                               id="active"
// //                               {...field}
// //                               value={true}
// //                               checked={values.isActive === true}
// //                               onChange={() => setFieldValue("isActive", true)}
// //                             />
// //                           )}
// //                         </Field>
// //                       </div>
// //                       <label htmlFor="active">Active</label>
// //                     </div>

// //                     <div className="form-group d-flex justify-content-center align-items-center gap-2">
// //                       <div className="radio-button-group">
// //                         <Field name="isActive">
// //                           {({ field }) => (
// //                             <input
// //                               type="radio"
// //                               id="inactive"
// //                               {...field}
// //                               value={false}
// //                               checked={values.isActive === false}
// //                               onChange={() => setFieldValue("isActive", false)}
// //                             />
// //                           )}
// //                         </Field>
// //                       </div>
// //                       <label htmlFor="inactive">Inactive</label>
// //                     </div>
// //                   </div>

// //                   {/* Display Validation Error if needed */}
// //                   <ErrorMessage
// //                     className="form-text text-danger"
// //                     name="isActive"
// //                     component="span"
// //                   />
// //                 </div>
// //               </div>
// //               {/* Submit Button */}
// //               <div className="modal-footer d-flex justify-content-center">
// //                 {canWrite === true ? (
// //                   <button
// //                     type="submit"
// //                     className="deployment-button"
// //                     disabled={isSubmit}
// //                   >
// //                     {isSubmit ? (
// //                       <l-waveform
// //                         size="20"
// //                         stroke="3.5"
// //                         speed="1"
// //                         color="black"
// //                       ></l-waveform>
// //                     ) : (
// //                       <>
// //                         <i className="fa-solid fa-check done-container"></i>
// //                         {editVehicleData ? "Update" : "Save"}
// //                       </>
// //                     )}
// //                   </button>
// //                 ) : (
// //                   ""
// //                 )}
// //               </div>
// //             </div>
// //           </Form>
// //         )}
// //       </Formik>
// //     </div>
// //   );
// // };

// // export default AddVehicleForm;



































// import React, { useEffect, useState } from "react";
// import FileInput from "./form_fields/FileInput";
// import RadioInput from "./form_fields/RadioInput";
// import BaseFormComponent from "./form_fields/BaseFormComponent";
// import SelectInput from "./form_fields/SelectInput";
// import Select from 'react-select';
// import * as Yup from "yup";
// import { toast } from "react-toastify";
// import { useDropdownStore } from "./store/useDropdownStore";
// import { Formik, Form, ErrorMessage, Field, FieldArray } from "formik";
// import FilePreview from "./FilePreview";
// import { useVehicleStore } from "./store/useVehicleStore";
// import getValidationSchema from "./getValidationSchema";
// import { waveform } from "ldrs";
// import { handleUuid } from "../../../utils/ValidationsHelper";
// import { getWritePermission } from "./utils/helpers";
// import RouteMastersStore from "../RouteMaster/store/useRouteMasterStore";

// const AddVehicleForm = ({
//   handleSearch,
//   editVehicleData,
//   setEditVehicleData,
//   handleClose,
// }) => {
//   const {
//     fuelTypes,
//     collectionTypes,
//     vehicleTypes,
//     ownerTypes,
//     vehicleCapacities,
//     zones,
//     circles,
//     wards,
//     drivers,
//     primaryDeploymentIncharges,
//     secondaryDeploymentIncharges,
//     transferStations,
//     loading,
//     vehicleStatus,
//     fileInputs,
//     filePreviews,
//     resetFileInputs,
//     fetchVehicleTypes,
//     fetchOwnerTypes,
//     fetchVehicleCapacities,
//     fetchVehicleStatus,
//     fetchFuelTypes,
//     fetchCollectionTypes,
//     fetchZones,
//     fetchCircles,
//     fetchWards,
//     fetchDrivers,
//     fetchPrimaryDeploymentIncharges,
//     fetchSecondaryDeploymentIncharges,
//     fetchTransferStations,
//     handleFileChange,
//     updateFilePreview,
//     fetchAllVehicleCategories,
//     vehicleCategoryData,
//     fetchAllRouteStartAndEndPoints,
//     routestartAndEndPointsData,
//   } = useDropdownStore();
//   const { fetchRouteMasters, routeMasterData } = RouteMastersStore();
//   const { saveVehicleDetails } = useVehicleStore();
//   const canWrite = getWritePermission();

//   const [collectionTypeId, setCollectionTypeId] = useState(editVehicleData?.collectionTypeId || "");
//   const [isSubmit, setIsSubmit] = useState(false);
//   const [tripRows, setTripRows] = useState([{
//     id: Date.now(),
//     routeCode: '',
//     startingCollectionPointId: '',
//     endingCollectionPointId: '',
//     shifts: [],
//     isNew: true
//   }]);
//   const [routePointsByTrip, setRoutePointsByTrip] = useState({});
//   waveform.register();

//   useEffect(() => {
//     fetchFuelTypes();
//     fetchCollectionTypes();
//     fetchVehicleStatus();
//     fetchOwnerTypes();
//     fetchZones();
//     fetchDrivers();
//     fetchPrimaryDeploymentIncharges();
//     fetchSecondaryDeploymentIncharges();
//     fetchTransferStations();
//     fetchAllVehicleCategories();
//     fetchRouteMasters();

//     if (editVehicleData) {
//       fetchVehicleTypes(editVehicleData?.collectionTypeId);
//       fetchVehicleCapacities(editVehicleData?.vehicleTypeId);
//       fetchCircles(editVehicleData?.zoneId);
//       fetchWards(editVehicleData?.circleId);
//       fetchDrivers(editVehicleData?.collectionTypeId);
//       setCollectionTypeId(editVehicleData?.collectionTypeId || "");
//       updateFilePreview(
//         editVehicleData?.vehicleImageUrl ?? null,
//         editVehicleData?.rcimageUrl ?? null,
//         editVehicleData?.pcimageUrl ?? null
//       );

//       if (editVehicleData?.mappings?.length) {
//         const reverseShiftMap = { 1: 'A', 2: 'B', 3: 'C' };
//         const newTripRows = editVehicleData.mappings.map((mapping, index) => ({
//           id: Date.now() + index,
//           routeToVehicleMappingId: mapping.routeToVehicleMappingId || null,
//           routeCode: mapping.routeCode || '',
//           startingCollectionPointId: mapping.startingCollectionPointId?.toString() || '',
//           endingCollectionPointId: mapping.endingCollectionPointId?.toString() || '',
//           shifts: Array.isArray(mapping.shiftIds)
//             ? mapping.shiftIds.map(id => reverseShiftMap[Number(id)]).filter(Boolean)
//             : mapping.shiftId
//               ? mapping.shiftId.split(',').map(id => reverseShiftMap[Number(id.trim())]).filter(Boolean)
//               : [],
//           isNew: false,
//         }));
//         setTripRows(newTripRows);
//       }
//     }
//   }, [editVehicleData]);

//   const initialVehicleDetails = {
//     vehicleNumber: editVehicleData?.vehicleNumber || "",
//     chassisNumber: editVehicleData?.chassisNumber || "",
//     fuelTypeId: editVehicleData?.fuelTypeId || "",
//     collectionTypeId: editVehicleData?.collectionTypeId || "",
//     vehicleTypeId: editVehicleData?.vehicleTypeId || "",
//     vehicleCapacityId: editVehicleData?.vehicleCapacityId || "",
//     vehicleStatusId: editVehicleData?.vehicleStatusId || "",
//     ownerTypeId: editVehicleData?.ownerTypeId || "",
//     vehicleUuid: editVehicleData?.vehicleUuid || "",
//     zoneId: editVehicleData?.zoneId || "",
//     circleId: editVehicleData?.circleId || "",
//     driverId: editVehicleData?.driverId || "",
//     RFID: editVehicleData?.rfid || "",
//     primaryDeploymentInchargeId: editVehicleData?.primaryDeploymentInchargeId || "",
//     secondaryDeploymentInchargeId: editVehicleData?.secondaryDeploymentInchargeId || "",
//     transferStationId: editVehicleData?.transferStationId || "",
//     vehicleImageUrl: null,
//     rcimageUrl: null,
//     pcimageUrl: null,
//     vehicleBrandName: editVehicleData?.vehicleBrandName || "",
//     contractorName: editVehicleData?.contractorName || "",
//     vehicleCategoryId: editVehicleData?.vehicleCategoryId || "",
//     remark: editVehicleData?.remark || "",
//     isActive: editVehicleData?.isActive ?? true,
//     fuelTypeName: editVehicleData?.fuelTypeName || "",
//     collectionTypeName: editVehicleData?.collectionTypeName || "",
//     ownerTypeName: editVehicleData?.ownerTypeName || "",
//     transferStationName: editVehicleData?.transferStationName || "",
//     vehicleTypeName: editVehicleData?.vehicleTypeName || "",
//     vehicleCapacityName: editVehicleData?.vehicleCapacityName || "",
//     vehicleStatusName: editVehicleData?.vehicleStatusName || "",
//     DriverNumber: editVehicleData?.driverNumber || "",
//     DriverName: editVehicleData?.driverName || "",
//     PrimaryDeploymentInchargeName: editVehicleData?.primaryDeploymentInchargeName || "",
//     PrimaryDeploymentInchargeNumber: editVehicleData?.primaryDeploymentInchargeNumber || "",
//     SecondaryDeploymentInchargeNumber: editVehicleData?.SecondaryDeploymentInchargeNumber || "",
//     SecondaryDeploymentInchargeName: editVehicleData?.secondaryDeploymentInchargeName || "",
//     mappings: tripRows.map(row => ({
//       routeCode: row.routeCode,
//       startingCollectionPointId: row.startingCollectionPointId,
//       endingCollectionPointId: row.endingCollectionPointId,
//       shifts: row.shifts
//     })),
//     ...(editVehicleData?.vehicleId && { vehicleId: editVehicleData.vehicleId }),
//   };

//   const handleRouteCodeChange = async (tripIndex, routeCode, setFieldValue) => {
//     setFieldValue(`mappings.${tripIndex}.routeCode`, routeCode);
//    setTripRows(prevRows =>
//       prevRows.map((row, idx) =>
//         idx === tripIndex ? { ...row, routeCode, startingCollectionPointId: '', endingCollectionPointId: '' } : row
//       )
//     );

//     setRoutePointsByTrip(prev => {
//       const newPoints = { ...prev };
//       delete newPoints[tripIndex];
//       return newPoints;
//     });
   
//     if (routeCode) {
//       try {
//          await fetchAllRouteStartAndEndPoints(routeCode);
//         if (routestartAndEndPointsData) {
//           // Assuming routestartAndEndPointsData contains the response object
//           const responseData = routestartAndEndPointsData;

//           // Store the response data for the trip
//           setRoutePointsByTrip(prev => ({
//             ...prev,
//             [tripIndex]: [responseData], // Wrap in array for consistency with getAvailableCollectionPoints
//           }));


//           // Set the Start and End Point values from the response
//           const startPointId = responseData.startingCollectionPointId || '';
//           const endPointId = responseData.endingCollectionPointId || '';


//           setFieldValue(`mappings.${tripIndex}.startingCollectionPointId`, startPointId);
//           setFieldValue(`mappings.${tripIndex}.endingCollectionPointId`, endPointId);

//           // Update tripRows to reflect the selected values
//           setTripRows(tripRows.map((row, idx) => idx === tripIndex ? {
//             ...row,
//             startingCollectionPointId: startPointId,
//             endingCollectionPointId: endPointId,
//           } : row));
//         } else {
//           toast.warn('No route points found for the selected route code');
//           setRoutePointsByTrip(prev => {
//             const newPoints = { ...prev };
//             delete newPoints[tripIndex];
//             return newPoints;
//           });
//           setFieldValue(`mappings.${tripIndex}.startingCollectionPointId`, '');
//           setFieldValue(`mappings.${tripIndex}.endingCollectionPointId`, '');
//         }
//       } catch (error) {
//         console.error('Error fetching route points:', error);
//         toast.error('Failed to fetch route points');
//         setRoutePointsByTrip(prev => {
//           const newPoints = { ...prev };
//           delete newPoints[tripIndex];
//           return newPoints;
//         });
//         setFieldValue(`mappings.${tripIndex}.startingCollectionPointId`, '');
//         setFieldValue(`mappings.${tripIndex}.endingCollectionPointId`, '');
//       }
//     } else {
//       setRoutePointsByTrip(prev => {
//         const newPoints = { ...prev };
//         delete newPoints[tripIndex];
//         return newPoints;
//       });
//       setFieldValue(`mappings.${tripIndex}.startingCollectionPointId`, '');
//       setFieldValue(`mappings.${tripIndex}.endingCollectionPointId`, '');
//       setTripRows(tripRows.map((row, idx) => idx === tripIndex ? {
//         ...row,
//         startingCollectionPointId: '',
//         endingCollectionPointId: '',
//       } : row));
//     }
//   };

//   const getAvailableCollectionPoints = (tripIndex, column) => {
//     const points = routePointsByTrip[tripIndex] || [];
//     const currentRow = tripRows[tripIndex];
//     let availablePoints = points;

//     // Map the response to dropdown options
//     const options = availablePoints.map(point => ({
//       value: column === 'startingCollectionPointId'
//         ? point.startingCollectionPointId
//         : point.endingCollectionPointId,
//       label: column === 'startingCollectionPointId'
//         ? point.startingCollectionPointName
//         : point.endingCollectionPointName,
//     }));

//     // Filter out the selected opposite point to prevent duplicates
//     if (column === 'startingCollectionPointId' && currentRow?.endingCollectionPointId) {
//       return options.filter(option => option.value !== currentRow.endingCollectionPointId);
//     }
//     if (column === 'endingCollectionPointId' && currentRow?.startingCollectionPointId) {
//       return options.filter(option => option.value !== currentRow.startingCollectionPointId);
//     }

//     return options;
//   };

//   const handleShiftChange = (rowId, shift, setFieldValue) => {
//     setTripRows(tripRows.map(row => {
//       if (row.id === rowId) {
//         const updatedShifts = row.shifts.includes(shift)
//           ? row.shifts.filter(s => s !== shift)
//           : [...row.shifts, shift];
//         const tripIndex = tripRows.findIndex(r => r.id === rowId);
//         setFieldValue(`mappings.${tripIndex}.shifts`, updatedShifts);
//         return { ...row, shifts: updatedShifts };
//       }
//       return row;
//     }));
//   };

//   const handleSubmit = async (values, { resetForm, setErrors }) => {
//     setIsSubmit(true);
//     const shiftMap = { A: 1, B: 2, C: 3 };
//     const formattedTrips = tripRows.map(row => ({
//       StartingCollectionPointId: row.startingCollectionPointId ? Number(row.startingCollectionPointId) : undefined,
//       EndingCollectionPointId: row.endingCollectionPointId ? Number(row.endingCollectionPointId) : undefined,
//       ShiftIds: row.shifts.map(shift => shiftMap[shift]).filter(Boolean),
//       routeCode: row.routeCode,
//       ...(row.routeToVehicleMappingId && { routeToVehicleMappingId: row.routeToVehicleMappingId }),
//     }));
//     console.log(formattedTrips)
//     const validTrips = formattedTrips.filter(
//       trip => trip.StartingCollectionPointId && trip.EndingCollectionPointId && trip.ShiftIds.length && trip.routeCode
//     );
//     const formattedValues = {
//       ...values,
//       wardId: values.wardId ? values.wardId : undefined,
//       PrimaryDeploymentInchargeName: values.collectionTypeId === "2" ? "" : values.PrimaryDeploymentInchargeName,
//       PrimaryDeploymentInchargeNumber: values.collectionTypeId === "2" ? "" : values.PrimaryDeploymentInchargeNumber,
//       SecondaryDeploymentInchargeNumber: values.collectionTypeId === "1" ? "" : values.SecondaryDeploymentInchargeNumber,
//       SecondaryDeploymentInchargeName: values.collectionTypeId === "1" ? "" : values.SecondaryDeploymentInchargeName,
//       mappings: JSON.stringify(formattedTrips),
//     };
//     try {
//       await saveVehicleDetails(formattedValues, editVehicleData);
//       handleSearch();
//       toast.success(editVehicleData ? "Vehicle updated successfully" : "New Vehicle added successfully");
//       setEditVehicleData(null);
//       handleClose();
//       resetFileInputs();
//       setIsSubmit(false);
//       resetForm();
//     } catch (xhr) {
//       console.error("Submission error:", xhr);
//       if (xhr?.response?.data?.errors && typeof xhr.response.data.errors === "object") {
//         const formErrors = {};
//         Object.keys(xhr.response.data.errors).forEach(key => {
//           if (Array.isArray(xhr.response.data.errors[key]) && xhr.response.data.errors[key].length) {
//             formErrors[key] = xhr.response.data.errors[key][0];
//             toast.error(`${key}: ${xhr.response.data.errors[key][0]}`);
//           }
//         });
//         setErrors(formErrors);
//       } else {
//         toast.error(xhr.response?.data || "An error occurred while saving the vehicle.");
//       }
//       setIsSubmit(false);
//     }
//   };

//   const handleSpecialCharacters = e => {
//     const value = e.target.value;
//     const sanitizedValue = value
//       .replace(/[^a-zA-Z0-9\s]/g, "")
//       .replace(/^\s+/, "")
//       .replace(/\s{2,}/g, " ");
//     e.target.value = sanitizedValue;
//   };

//   return (
//     <div>
//       <Formik
//         initialValues={initialVehicleDetails}
//         validationSchema={getValidationSchema(collectionTypeId, editVehicleData)}
//         onSubmit={handleSubmit}
//         validateOnChange={true}
//         validateOnBlur={true}
//         enableReinitialize={true}
//       >
//         {({
//           values,
//           setFieldValue,
//           setFieldError,
//           resetForm,
//           setFieldTouched,
//           setErrors,
//           setTouched,
//         }) => (
//           <Form>
//             <div className="row">
//               <BaseFormComponent
//                 label="Vehicle Number"
//                 name="vehicleNumber"
//                 type="text"
//                 placeholder="Enter Vehicle Registration Number"
//                 required
//               />
//               <BaseFormComponent
//                 label="Vehicle Chassis Number"
//                 name="chassisNumber"
//                 type="text"
//                 max="30"
//                 handleSpecialCharacters={handleSpecialCharacters}
//                 placeholder="Enter Vehicle Chassis Number"
//               />
//               <div className="col-md-4">
//                 <div className="form-group">
//                   <label className="form-label">
//                     Fuel Type
//                     <span style={{ color: "#EC1117" }}> *</span>
//                   </label>
//                   <Field
//                     as="select"
//                     name="fuelTypeId"
//                     className="form-select"
//                     onChange={e => {
//                       const selectedFuelTypeId = e.target.value;
//                       setFieldValue("fuelTypeId", selectedFuelTypeId);
//                       setFieldTouched("fuelTypeId", false);
//                       setFieldError("fuelTypeId", "");
//                       const selectedFuelType = fuelTypes.find(
//                         fuelType => fuelType.fuelTypeId === Number(selectedFuelTypeId)
//                       );
//                       if (selectedFuelType) {
//                         setFieldValue("fuelTypeName", selectedFuelType.fuelTypeName);
//                       }
//                     }}
//                   >
//                     <option value="">Select</option>
//                     {fuelTypes.map(fuelType => (
//                       <option key={fuelType.fuelTypeId} value={fuelType.fuelTypeId}>
//                         {fuelType.fuelTypeName}
//                       </option>
//                     ))}
//                   </Field>
//                   <ErrorMessage
//                     className="form-text text-danger"
//                     name="fuelTypeId"
//                     component="span"
//                   />
//                 </div>
//               </div>
//               <div className="col-md-4">
//                 <div className="form-group">
//                   <label className="form-label">
//                     Collection Type
//                     <span style={{ color: "#EC1117" }}> *</span>
//                   </label>
//                   <Field
//                     as="select"
//                     name="collectionTypeId"
//                     className="form-select"
//                     onChange={e => {
//                       const selectedValue = e.target.value;
//                       const previousValue = values.collectionTypeId;
//                       setFieldValue("collectionTypeId", selectedValue);
//                       setFieldTouched("collectionTypeId", false);
//                       setFieldError("collectionTypeId", "");
//                       if (previousValue === "1" && selectedValue !== "1") {
//                         setFieldValue("driverId", "");
//                         setFieldTouched("driverId", false);
//                         setFieldError("driverId", "");
//                       }
//                       if (selectedValue) {
//                         setCollectionTypeId(selectedValue);
//                         fetchVehicleTypes(selectedValue);
//                         fetchDrivers(selectedValue);
//                         if (selectedValue === "1") {
//                           fetchPrimaryDeploymentIncharges();
//                         } else if (selectedValue === "2") {
//                           fetchSecondaryDeploymentIncharges();
//                         }
//                       }
//                       const selectedCollectionType = collectionTypes.find(
//                         collectionType => collectionType.collectionTypeId === Number(selectedValue)
//                       );
//                       if (selectedCollectionType) {
//                         setFieldValue("collectionTypeName", selectedCollectionType.collectionTypeName);
//                       }
//                     }}
//                   >
//                     <option value="">Select</option>
//                     {collectionTypes.map(collectionType => (
//                       <option
//                         key={collectionType.collectionTypeId}
//                         value={collectionType.collectionTypeId}
//                       >
//                         {collectionType.collectionTypeName}
//                       </option>
//                     ))}
//                   </Field>
//                   <ErrorMessage
//                     className="form-text text-danger"
//                     name="collectionTypeId"
//                     component="span"
//                   />
//                 </div>
//               </div>
//               <div className="col-md-4">
//                 <div className="form-group">
//                   <label className="form-label">
//                     Vehicle Type
//                     <span style={{ color: "#EC1117" }}> *</span>
//                   </label>
//                   <Field
//                     as="select"
//                     name="vehicleTypeId"
//                     className="form-select"
//                     onChange={e => {
//                       setFieldValue("vehicleTypeId", e.target.value);
//                       setFieldTouched("vehicleTypeId", false);
//                       setFieldError("vehicleTypeId", "");
//                       if (e.target.value) {
//                         fetchVehicleCapacities(e.target.value);
//                       }
//                       const selectedVehicleTypeId = e.target.value;
//                       const selectedVehicleType = vehicleTypes.find(
//                         vehicleType => vehicleType.vehicleTypeId === Number(selectedVehicleTypeId)
//                       );
//                       if (selectedVehicleType) {
//                         setFieldValue("vehicleTypeName", selectedVehicleType.vehicleTypeName);
//                       }
//                     }}
//                   >
//                     <option value="">Select</option>
//                     {vehicleTypes
//                       .filter(vehicleType => vehicleType.isActive)
//                       .map(vehicleType => (
//                         <option
//                           key={vehicleType.vehicleTypeId}
//                           value={vehicleType.vehicleTypeId}
//                         >
//                           {vehicleType.vehicleTypeName}
//                         </option>
//                       ))}
//                   </Field>
//                   <ErrorMessage
//                     className="form-text text-danger"
//                     name="vehicleTypeId"
//                     component="span"
//                   />
//                 </div>
//               </div>
//               <div className="col-md-4">
//                 <div className="form-group">
//                   <label className="form-label">
//                     Vehicle Capacity
//                     <span style={{ color: "#EC1117" }}> *</span>
//                   </label>
//                   <Field
//                     as="select"
//                     name="vehicleCapacityId"
//                     className="form-select"
//                     onChange={e => {
//                       const selectedVehicleCapacityId = e.target.value;
//                       setFieldValue("vehicleCapacityId", e.target.value);
//                       setFieldTouched("vehicleCapacityId", false);
//                       setFieldError("vehicleCapacityId", "");
//                       const selectedVehicleCapacity = vehicleCapacities.find(
//                         vehicleCapacity => vehicleCapacity.vehicleCapacityId === Number(selectedVehicleCapacityId)
//                       );
//                       if (selectedVehicleCapacity) {
//                         setFieldValue("vehicleCapacityName", selectedVehicleCapacity.vehicleCapacityName);
//                       }
//                     }}
//                   >
//                     <option value="">Select</option>
//                     {vehicleCapacities
//                       .filter(vehicleCapacity => vehicleCapacity.isActive)
//                       .map(vehicleCapacity => (
//                         <option
//                           key={vehicleCapacity.vehicleCapacityId}
//                           value={vehicleCapacity.vehicleCapacityId}
//                         >
//                           {vehicleCapacity.vehicleCapacityName}
//                         </option>
//                       ))}
//                   </Field>
//                   <ErrorMessage
//                     className="form-text text-danger"
//                     name="vehicleCapacityId"
//                     component="span"
//                   />
//                 </div>
//               </div>
//               <div className="col-md-4">
//                 <div className="form-group">
//                   <label className="form-label">
//                     Vehicle Status
//                     <span style={{ color: "#EC1117" }}> *</span>
//                   </label>
//                   <Field
//                     as="select"
//                     name="vehicleStatusId"
//                     className="form-select"
//                     onChange={e => {
//                       const selectedVehicleStatusId = e.target.value;
//                       setFieldValue("vehicleStatusId", e.target.value);
//                       setFieldTouched("vehicleStatusId", false);
//                       setFieldError("vehicleStatusId", "");
//                       const selectedVehicleStatus = vehicleStatus.find(
//                         status => status.vehicleStatusId === Number(selectedVehicleStatusId)
//                       );
//                       Number(selectedVehicleStatusId) === 2
//                         ? setFieldValue("isActive", false)
//                         : setFieldValue("isActive", true);
//                       setFieldValue("vehicleStatusName", selectedVehicleStatus?.vehicleStatusName);
//                     }}
//                   >
//                     <option value="">Select</option>
//                     {vehicleStatus.map(status => (
//                       <option key={status.vehicleStatusId} value={status.vehicleStatusId}>
//                         {status.vehicleStatusName}
//                       </option>
//                     ))}
//                   </Field>
//                   <ErrorMessage
//                     className="form-text text-danger"
//                     name="vehicleStatusId"
//                     component="span"
//                   />
//                 </div>
//               </div>
//               <div className="col-md-4">
//                 <div className="form-group">
//                   <label className="form-label">
//                     Owner Type
//                     <span style={{ color: "#EC1117" }}> *</span>
//                   </label>
//                   <Field
//                     as="select"
//                     name="ownerTypeId"
//                     className="form-select"
//                     onChange={e => {
//                       const selectedOwnerTypeId = e.target.value;
//                       setFieldValue("ownerTypeId", e.target.value);
//                       setFieldTouched("ownerTypeId", false);
//                       setFieldError("ownerTypeId", "");
//                       const selectedOwnerType = ownerTypes.find(
//                         ownerType => ownerType.ownerTypeId === Number(selectedOwnerTypeId)
//                       );
//                       if (selectedOwnerType) {
//                         setFieldValue("ownerTypeName", selectedOwnerType.ownerTypeName);
//                       }
//                     }}
//                   >
//                     <option value="">Select</option>
//                     {ownerTypes
//                       .filter(owner => owner.isActive)
//                       .map(owner => (
//                         <option key={owner.ownerTypeId} value={owner.ownerTypeId}>
//                           {owner.ownerTypeName}
//                         </option>
//                       ))}
//                   </Field>
//                   <ErrorMessage
//                     className="form-text text-danger"
//                     name="ownerTypeId"
//                     component="span"
//                   />
//                 </div>
//               </div>
//               <div className="col-md-4">
//                 <div className="form-group">
//                   <label className="form-label">
//                     Vehicle UID
//                     <span style={{ color: "#EC1117" }}> *</span>
//                   </label>
//                   <Field
//                     type="text"
//                     id="vehicleUuid"
//                     maxLength="20"
//                     name="vehicleUuid"
//                     onInput={handleUuid}
//                     className="form-control"
//                     placeholder="Enter Vehicle UID"
//                   />
//                   <ErrorMessage
//                     className="form-text text-danger"
//                     name="vehicleUuid"
//                     component="span"
//                   />
//                 </div>
//               </div>
//               <div className="col-md-4">
//                 <div className="form-group">
//                   <label className="form-label">
//                     Zone
//                     <span style={{ color: "#EC1117" }}> *</span>
//                   </label>
//                   <Field
//                     as="select"
//                     name="zoneId"
//                     className="form-select"
//                     onChange={e => {
//                       setFieldValue("zoneId", e.target.value);
//                       setFieldValue("circleId", "");
//                       setFieldValue("wardId", "");
//                       setFieldTouched("zoneId", false);
//                       setFieldError("zoneId", "");
//                       if (e.target.value) {
//                         fetchCircles(e.target.value);
//                         fetchWards(e.target.value);
//                       } else {
//                         fetchCircles([]);
//                         fetchWards([]);
//                       }
//                     }}
//                   >
//                     <option value="">Select</option>
//                     {zones
//                       .filter(zone => zone.isActive)
//                       .map(zone => (
//                         <option key={zone.zoneId} value={zone.zoneId}>
//                           {zone.zoneName}
//                         </option>
//                       ))}
//                   </Field>
//                   <ErrorMessage
//                     className="form-text text-danger"
//                     name="zoneId"
//                     component="span"
//                   />
//                 </div>
//               </div>
//               <div className="col-md-4">
//                 <div className="form-group">
//                   <label className="form-label">
//                     Ward
//                     {[1, 2].includes(Number(values.collectionTypeId)) && (
//                       <span style={{ color: "#EC1117" }}> *</span>
//                     )}
//                   </label>
//                   <Field
//                     as="select"
//                     name="circleId"
//                     className="form-select"
//                     onChange={e => {
//                       setFieldValue("circleId", e.target.value);
//                       setFieldValue("wardId", "");
//                       setFieldTouched("circleId", false);
//                       setFieldError("circleId", "");
//                       if (e.target.value) {
//                         fetchWards(e.target.value);
//                       } else {
//                         fetchWards([]);
//                       }
//                     }}
//                   >
//                     <option value="">Select</option>
//                     {Array.isArray(circles) && circles.length > 0 ? (
//                       circles.map(circle => (
//                         <option key={circle.circleId} value={circle.circleId}>
//                           {circle.circleName}
//                         </option>
//                       ))
//                     ) : (
//                       <option value="" disabled>
//                         No Wards found
//                       </option>
//                     )}
//                   </Field>
//                   <ErrorMessage
//                     className="form-text text-danger"
//                     name="circleId"
//                     component="span"
//                   />
//                 </div>
//               </div>
//               <div className="col-md-4">
//                 <div className="form-group" title={values.DriverName + " " + values.DriverNumber}>
//                   <label className="form-label">
//                     Driver Name
//                     {[1].includes(Number(values.collectionTypeId)) && (
//                       <span style={{ color: "#EC1117" }}> *</span>
//                     )}
//                   </label>
//                   <Field name="driverId">
//                     {({ field, form }) => (
//                       <Select
//                         {...field}
//                         options={drivers
//                           .filter(driver => driver.isActive)
//                           .map(driver => ({
//                             value: driver.driverId,
//                             label: `${driver.driverName} [${driver.mobileNumber}]`,
//                           }))}
//                         classNamePrefix="CreatableSelect"
//                         placeholder="Select"
//                         value={drivers
//                           .filter(driver => driver.isActive)
//                           .map(driver => ({
//                             value: driver.driverId,
//                             label: `${driver.driverName} [${driver.mobileNumber}]`,
//                           }))
//                           .find(option => option.value === field.value)}
//                         onChange={selectedOption => {
//                           const selectedDriverId = selectedOption ? selectedOption.value : '';
//                           form.setFieldValue("driverId", selectedDriverId);
//                           const selectedDriver = drivers.find(
//                             driver => driver.driverId === Number(selectedDriverId)
//                           );
//                           if (selectedDriver) {
//                             setFieldValue("DriverName", selectedDriver.driverName);
//                             setFieldValue("DriverNumber", selectedDriver.mobileNumber);
//                             setFieldTouched("driverId", false);
//                             setFieldError("driverId", "");
//                           } else {
//                             setFieldValue("DriverName", "");
//                             setFieldValue("DriverNumber", "");
//                           }
//                         }}
//                         onBlur={() => setFieldTouched("driverId", true)}
//                         isClearable={true}
//                         isSearchable={true}
//                       />
//                     )}
//                   </Field>
//                   <ErrorMessage
//                     className="form-text text-danger"
//                     name="driverId"
//                     component="span"
//                   />
//                 </div>
//               </div>
//               {Number(values.collectionTypeId) === 1 && (
//                 <div className="col-md-4">
//                   <div className="form-group" title={values.PrimaryDeploymentInchargeName + " " + values.PrimaryDeploymentInchargeNumber}>
//                     <label className="form-label">
//                       SFA Incharge
//                       <span style={{ color: "#EC1117" }}> *</span>
//                     </label>
//                     <Field name="primaryDeploymentInchargeId">
//                       {({ field, form }) => (
//                         <Select
//                           {...field}
//                           options={primaryDeploymentIncharges
//                             .filter(incharge => incharge.isActive)
//                             .map(incharge => ({
//                               value: incharge.primaryDeploymentInchargeId,
//                               label: `${incharge.primaryDeploymentInchargeName} [${incharge.mobileNumber}]`,
//                             }))}
//                           classNamePrefix="CreatableSelect"
//                           placeholder="Select"
//                           value={primaryDeploymentIncharges
//                             .filter(incharge => incharge.isActive)
//                             .map(incharge => ({
//                               value: incharge.primaryDeploymentInchargeId,
//                               label: `${incharge.primaryDeploymentInchargeName} [${incharge.mobileNumber}]`,
//                             }))
//                             .find(option => option.value === field.value)}
//                           onChange={selectedOption => {
//                             const selectedPrimaryDeploymentInchargeId = selectedOption ? selectedOption.value : '';
//                             form.setFieldValue("primaryDeploymentInchargeId", selectedPrimaryDeploymentInchargeId);
//                             const selectedIncharge = primaryDeploymentIncharges.find(
//                               incharge => incharge.primaryDeploymentInchargeId === Number(selectedPrimaryDeploymentInchargeId)
//                             );
//                             if (selectedIncharge) {
//                               setFieldValue("PrimaryDeploymentInchargeName", selectedIncharge.primaryDeploymentInchargeName);
//                               setFieldValue("PrimaryDeploymentInchargeNumber", selectedIncharge.mobileNumber);
//                               setFieldTouched("primaryDeploymentInchargeId", false);
//                               setFieldError("primaryDeploymentInchargeId", "");
//                             } else {
//                               setFieldValue("PrimaryDeploymentInchargeName", "");
//                               setFieldValue("PrimaryDeploymentInchargeNumber", "");
//                             }
//                           }}
//                           onBlur={() => setFieldTouched("primaryDeploymentInchargeId", true)}
//                           isClearable={true}
//                           isSearchable={true}
//                         />
//                       )}
//                     </Field>
//                     <ErrorMessage
//                       className="form-text text-danger"
//                       name="primaryDeploymentInchargeId"
//                       component="span"
//                     />
//                   </div>
//                 </div>
//               )}
//               {Number(values.collectionTypeId) === 2 && (
//                 <div className="col-md-4">
//                   <div className="form-group" title={values.SecondaryDeploymentInchargeName + " " + values.SecondaryDeploymentInchargeNumber}>
//                     <label className="form-label">
//                       Secondary Incharge
//                     </label>
//                     <Field name="secondaryDeploymentInchargeId">
//                       {({ field, form }) => (
//                         <Select
//                           {...field}
//                           options={secondaryDeploymentIncharges
//                             .filter(incharge => incharge.isActive)
//                             .map(incharge => ({
//                               value: incharge.secondaryDeploymentInchargeId,
//                               label: `${incharge.secondaryDeploymentInchargeName} [${incharge.mobileNumber}]`,
//                             }))}
//                           classNamePrefix="CreatableSelect"
//                           placeholder="Select"
//                           value={secondaryDeploymentIncharges
//                             .filter(incharge => incharge.isActive)
//                             .map(incharge => ({
//                               value: incharge.secondaryDeploymentInchargeId,
//                               label: `${incharge.secondaryDeploymentInchargeName} [${incharge.mobileNumber}]`,
//                             }))
//                             .find(option => option.value === field.value)}
//                           onChange={selectedOption => {
//                             const selectedSecondaryDeploymentInchargeId = selectedOption ? selectedOption.value : '';
//                             form.setFieldValue("secondaryDeploymentInchargeId", selectedSecondaryDeploymentInchargeId);
//                             const selectedIncharge = secondaryDeploymentIncharges.find(
//                               incharge => incharge.secondaryDeploymentInchargeId === Number(selectedSecondaryDeploymentInchargeId)
//                             );
//                             if (selectedIncharge) {
//                               form.setFieldValue("SecondaryDeploymentInchargeName", selectedIncharge.secondaryDeploymentInchargeName);
//                               form.setFieldValue("SecondaryDeploymentInchargeNumber", selectedIncharge.mobileNumber);
//                               form.setFieldTouched("secondaryDeploymentInchargeId", false);
//                               form.setFieldError("secondaryDeploymentInchargeId", "");
//                             } else {
//                               form.setFieldValue("SecondaryDeploymentInchargeName", "");
//                               form.setFieldValue("SecondaryDeploymentInchargeNumber", "");
//                             }
//                           }}
//                           onBlur={() => form.setFieldTouched("secondaryDeploymentInchargeId", true)}
//                           isClearable={true}
//                           isSearchable={true}
//                         />
//                       )}
//                     </Field>
//                     <ErrorMessage
//                       className="form-text text-danger"
//                       name="secondaryDeploymentInchargeId"
//                       component="span"
//                     />
//                   </div>
//                 </div>
//               )}
//               <div className="col-md-4">
//                 <div className="form-group" title={values.transferStationName}>
//                   <label className="form-label">
//                     Transfer Station
//                   </label>
//                   <Field name="transferStationId">
//                     {({ field, form }) => (
//                       <Select
//                         {...field}
//                         options={transferStations
//                           .filter(station => station.isActive)
//                           .map(station => ({
//                             value: station.transferStationId,
//                             label: station.transferStationName,
//                           }))}
//                         classNamePrefix="CreatableSelect"
//                         placeholder="Select"
//                         value={transferStations
//                           .filter(station => station.isActive)
//                           .map(station => ({
//                             value: station.transferStationId,
//                             label: station.transferStationName,
//                           }))
//                           .find(option => option.value === field.value)}
//                         onChange={selectedOption => {
//                           const selectedTransferStationId = selectedOption ? selectedOption.value : '';
//                           form.setFieldValue("transferStationId", selectedTransferStationId);
//                           const selectedStation = transferStations.find(
//                             station => station.transferStationId === Number(selectedTransferStationId)
//                           );
//                           if (selectedStation) {
//                             form.setFieldValue("transferStationName", selectedStation.transferStationName);
//                             form.setFieldTouched("transferStationId", false);
//                             form.setFieldError("transferStationId", "");
//                           } else {
//                             form.setFieldValue("transferStationName", "");
//                           }
//                         }}
//                         onBlur={() => form.setFieldTouched("transferStationId", true)}
//                         isClearable={true}
//                         isSearchable={true}
//                       />
//                     )}
//                   </Field>
//                   <ErrorMessage
//                     className="form-text text-danger"
//                     name="transferStationId"
//                     component="span"
//                   />
//                 </div>
//               </div>
//               {/* <div className="col-md-4">
//                 <div className="form-group">
//                   <label className="form-label">Vehicle Category</label>
//                   <Field as="select" name="vehicleCategoryId" className="form-select">
//                     <option value="">Select</option>
//                     {vehicleCategoryData.map(item => (
//                       <option key={item.vehicleCategoryId} value={item.vehicleCategoryId}>
//                         {item.vehicleCategoryName}
//                       </option>
//                     ))}
//                   </Field>
//                   <ErrorMessage
//                     className="form-text text-danger"
//                     name="vehicleCategoryId"
//                     component="span"
//                   />
//                 </div>
//               </div> */}
//               <div className="col-12">
//                 <h5>Trips</h5>
//                 <FieldArray name="mappings">
//                   {({ push, remove }) => (
//                     <div className="mb-3">
//                       {values.mappings.map((row, index) => (
//                         <div key={tripRows[index].id} className="mb-3">
//                           <h6>Trip - {index + 1}</h6>
//                           <div className="row align-items-end">
//                             <div className="col-md-3">
//                               <label className="form-label">
//                                 Route Code
//                                 <span style={{ color: "#EC1117" }}> *</span>
//                               </label>
//                              <Field name={`mappings.${index}.routeCode`}>
//                                 {({ field, form }) => (
//                                   <Select
//                                     {...field}
//                                     options={routeMasterData.map(route => ({
//                                       value: route.routeCode,
//                                       label: route.routeCode,
//                                     }))}
//                                     classNamePrefix="CreatableSelect"
//                                     placeholder="Select"
//                                     value={routeMasterData
//                                       .map(route => ({
//                                         value: route.routeCode,
//                                         label: route.routeCode,
//                                       }))
//                                       .find(option => option.value === field.value) || null}
//                                     onChange={selectedOption => {
//                                       const selectedValue = selectedOption ? selectedOption.value : '';
//                                       form.setFieldValue(`mappings.${index}.routeCode`, selectedValue);
//                                       form.setFieldTouched(`mappings.${index}.routeCode`, true);
//                                       handleRouteCodeChange(index, selectedValue, form.setFieldValue);
//                                     }}
//                                     onBlur={() => form.setFieldTouched(`mappings.${index}.routeCode`, true)}
//                                     isSearchable={true}
//                                   />
//                                 )}
//                               </Field>
//                               <ErrorMessage
//                                 className="form-text text-danger"
//                                 name={`mappings.${index}.routeCode`}
//                                 component="div"
//                               />
//                             </div>
//                             <div className="col-md-3">
//                               <label className="form-label">
//                                 Start Route Point
//                                 <span style={{ color: "#EC1117" }}> *</span>
//                               </label>
//                               <Field name={`mappings.${index}.startingCollectionPointId`}>
//                                 {({ field, form }) => (
//                                   <Select
//                                     {...field}
//                                     options={getAvailableCollectionPoints(index, 'startingCollectionPointId')}
//                                     classNamePrefix="CreatableSelect"
//                                     placeholder="Select"
//                                     value={getAvailableCollectionPoints(index, 'startingCollectionPointId')
//                                       .find(option => option.value === field.value) || null}
//                                     onChange={selectedOption => {
//                                       const selectedValue = selectedOption ? selectedOption.value : '';
//                                       form.setFieldValue(`mappings.${index}.startingCollectionPointId`, selectedValue);
//                                       form.setFieldTouched(`mappings.${index}.startingCollectionPointId`, true);
//                                       setTripRows(tripRows.map((row, idx) => idx === index ? { ...row, startingCollectionPointId: selectedValue } : row));
//                                     }}
//                                     onBlur={() => form.setFieldTouched(`mappings.${index}.startingCollectionPointId`, true)}
//                                     isClearable={true}
//                                     isSearchable={true}
//                                   />
//                                 )}
//                               </Field>
//                               <ErrorMessage
//                                 className="form-text text-danger"
//                                 name={`mappings.${index}.startingCollectionPointId`}
//                                 component="div"
//                               />
//                             </div>
//                             <div className="col-md-3">
//                               <label className="form-label">
//                                 End Route Point
//                                 <span style={{ color: "#EC1117" }}> *</span>
//                               </label>
//                               <Field name={`mappings.${index}.endingCollectionPointId`}>
//                                 {({ field, form }) => (
//                                   <Select
//                                     {...field}
//                                     options={getAvailableCollectionPoints(index, 'endingCollectionPointId')}
//                                     classNamePrefix="CreatableSelect"
//                                     placeholder="Select"
//                                     value={getAvailableCollectionPoints(index, 'endingCollectionPointId')
//                                       .find(option => option.value === field.value) || null}
//                                     onChange={selectedOption => {
//                                       const selectedValue = selectedOption ? selectedOption.value : '';
//                                       form.setFieldValue(`mappings.${index}.endingCollectionPointId`, selectedValue);
//                                       form.setFieldTouched(`mappings.${index}.endingCollectionPointId`, true);
//                                       setTripRows(tripRows.map((row, idx) => idx === index ? { ...row, endingCollectionPointId: selectedValue } : row));
//                                     }}
//                                     onBlur={() => form.setFieldTouched(`mappings.${index}.endingCollectionPointId`, true)}
//                                     isClearable={true}
//                                     isSearchable={true}
//                                   />
//                                 )}
//                               </Field>
//                               <ErrorMessage
//                                 className="form-text text-danger"
//                                 name={`mappings.${index}.endingCollectionPointId`}
//                                 component="div"
//                               />
//                             </div>
//                             <div className="col-md-3">
//                               <label className="form-label">
//                                 Shift
//                                 <span style={{ color: "#EC1117" }}> *</span>
//                               </label>
//                               <div className="d-flex gap-3">
//                                 {['A', 'B', 'C'].map(shift => (
//                                   <div key={shift} className="form-check">
//                                     <input
//                                       type="checkbox"
//                                       className="form-check-input"
//                                       id={`shift-${index}-${shift}`}
//                                       checked={values.mappings[index].shifts.includes(shift)}
//                                       onChange={() => handleShiftChange(tripRows[index].id, shift, setFieldValue)}
//                                     />
//                                     <label className="form-check-label" htmlFor={`shift-${index}-${shift}`}>
//                                       {shift}
//                                     </label>
//                                   </div>
//                                 ))}
//                               </div>
//                               <ErrorMessage
//                                 className="form-text text-danger"
//                                 name={`mappings.${index}.shifts`}
//                                 component="div"
//                               />
//                             </div>
//                             <div className="col-md-3 d-flex align-items-end">
//                               <button
//                                 type="button"
//                                 className="btn btn-primary me-2 mb-3"
//                                 onClick={() => {
//                                   const newRow = {
//                                     id: Date.now(),
//                                     routeCode: '',
//                                     startingCollectionPointId: '',
//                                     endingCollectionPointId: '',
//                                     shifts: [],
//                                     isNew: true
//                                   };
//                                   setTripRows([...tripRows, newRow]);
//                                   push({
//                                     routeCode: '',
//                                     startingCollectionPointId: '',
//                                     endingCollectionPointId: '',
//                                     shifts: []
//                                   });
//                                 }}
//                               >
//                                 <i className="fa-solid fa-plus"></i>
//                               </button>
//                               {values.mappings.length > 1 && (
//                                 <button
//                                   type="button"
//                                   className="btn btn-danger mb-3"
//                                   onClick={() => {
//                                     setTripRows(tripRows.filter((_, idx) => idx !== index));
//                                     remove(index);
//                                   }}
//                                 >
//                                   <i className="fa-solid fa-trash"></i>
//                                 </button>
//                               )}
//                             </div>
//                           </div>
//                         </div>
//                       ))}
//                     </div>
//                   )}
//                 </FieldArray>
//               </div>
//               <div className="col-12">
//                 <div className="row">
//                   <div className="col-md-4">
//                     <div className="form-group">
//                       <label htmlFor="vehicleImageUrl" className="form-label">
//                         Vehicle Insurance
//                       </label>
//                       <input
//                         type="file"
//                         id="vehicleImageUrl"
//                         name="vehicleImageUrl"
//                         accept=".png, .jpg, .jpeg"
//                         onChange={e => {
//                           handleFileChange(e, "vehicleImageUrl");
//                           setFieldValue("vehicleImageUrl", e.currentTarget.files[0]);
//                         }}
//                         className="form-control"
//                       />
//                       <ErrorMessage
//                         className="form-text text-danger"
//                         name="vehicleImageUrl"
//                         component="span"
//                       />
//                       {filePreviews.vehicleImageUrl?.fileUrl && (
//                         <FilePreview
//                           file={filePreviews.vehicleImageUrl.file}
//                           fileType={filePreviews.vehicleImageUrl.fileType}
//                           fileUrl={filePreviews.vehicleImageUrl.fileUrl}
//                         />
//                       )}
//                     </div>
//                   </div>
//                   <div className="col-md-4">
//                     <div className="form-group">
//                       <label htmlFor="rcimageUrl" className="form-label">
//                         Registration Certificate
//                       </label>
//                       <input
//                         type="file"
//                         id="rcimageUrl"
//                         name="rcimageUrl"
//                         accept="image/png, image/jpeg, image/jpg"
//                         onChange={e => {
//                           handleFileChange(e, "rcimageUrl");
//                           setFieldValue("rcimageUrl", e.currentTarget.files[0]);
//                         }}
//                         className="form-control"
//                       />
//                       <ErrorMessage
//                         className="form-text text-danger"
//                         name="rcimageUrl"
//                         component="span"
//                       />
//                       {filePreviews.rcimageUrl?.fileUrl && (
//                         <FilePreview
//                           file={filePreviews.rcimageUrl.file}
//                           fileType={filePreviews.rcimageUrl.fileType}
//                           fileUrl={filePreviews.rcimageUrl.fileUrl}
//                         />
//                       )}
//                     </div>
//                   </div>
//                   <div className="col-md-4">
//                     <div className="form-group">
//                       <label htmlFor="pcimageUrl" className="form-label">
//                         Pollution Certificate
//                       </label>
//                       <input
//                         type="file"
//                         id="pcimageUrl"
//                         name="pcimageUrl"
//                         accept=".png, .jpg, .jpeg"
//                         onChange={e => {
//                           handleFileChange(e, "pcimageUrl");
//                           setFieldValue("pcimageUrl", e.currentTarget.files[0]);
//                         }}
//                         className="form-control"
//                       />
//                       <ErrorMessage
//                         className="form-text text-danger"
//                         name="pcimageUrl"
//                         component="span"
//                       />
//                       {filePreviews.pcimageUrl?.fileUrl && (
//                         <FilePreview
//                           file={filePreviews.pcimageUrl.file}
//                           fileType={filePreviews.pcimageUrl.fileType}
//                           fileUrl={filePreviews.pcimageUrl.fileUrl}
//                         />
//                       )}
//                     </div>
//                   </div>
//                 </div>
//               </div>
//               <BaseFormComponent
//                 label="Vehicle Brand Name"
//                 name="vehicleBrandName"
//                 type="text"
//                 placeholder="Enter Vehicle Brand Name"
//                 max="42"
//                 handleSpecialCharacters={handleSpecialCharacters}
//               />
//               <BaseFormComponent
//                 label="Contractor Name"
//                 name="contractorName"
//                 type="text"
//                 placeholder="Enter Contractor Name"
//                 max="42"
//                 handleSpecialCharacters={handleSpecialCharacters}
//               />
//               <BaseFormComponent
//                 label="RFID"
//                 name="RFID"
//                 type="text"
//                 placeholder="Enter RFID"
//                 max="12"
//                 handleSpecialCharacters={handleSpecialCharacters}
//               />
//               <div className="col-md-12 mb-3">
//                 <div className="form-group">
//                   <label htmlFor="remark" className="form-label">
//                     Remarks
//                   </label>
//                   <Field
//                     as="textarea"
//                     id="remark"
//                     name="remark"
//                     className="form-control"
//                     maxLength="500"
//                     rows="3"
//                   />
//                   <ErrorMessage
//                     className="form-text text-danger"
//                     name="remark"
//                     component="span"
//                   />
//                 </div>
//               </div>
//               <div className="row" style={{ marginTop: "5px" }}>
//                 <div className="col-md-4">
//                   <label className="form-label">
//                     Status <span style={{ color: "#EC1117" }}> *</span>
//                   </label>
//                   <div className="d-flex gap-4">
//                     <div className="form-group d-flex justify-content-center align-items-center gap-2">
//                       <div className="radio-button-group">
//                         <Field name="isActive">
//                           {({ field }) => (
//                             <input
//                               type="radio"
//                               id="active"
//                               {...field}
//                               value={true}
//                               checked={values.isActive === true}
//                               onChange={() => setFieldValue("isActive", true)}
//                             />
//                           )}
//                         </Field>
//                       </div>
//                       <label htmlFor="active">Active</label>
//                     </div>
//                     <div className="form-group d-flex justify-content-center align-items-center gap-2">
//                       <div className="radio-button-group">
//                         <Field name="isActive">
//                           {({ field }) => (
//                             <input
//                               type="radio"
//                               id="inactive"
//                               {...field}
//                               value={false}
//                               checked={values.isActive === false}
//                               onChange={() => setFieldValue("isActive", false)}
//                             />
//                           )}
//                         </Field>
//                       </div>
//                       <label htmlFor="inactive">Inactive</label>
//                     </div>
//                   </div>
//                   <ErrorMessage
//                     className="form-text text-danger"
//                     name="isActive"
//                     component="span"
//                   />
//                 </div>
//               </div>
//               <div className="modal-footer d-flex justify-content-center">
//                 {canWrite && (
//                   <button
//                     type="submit"
//                     className="deployment-button"
//                     disabled={isSubmit}
//                   >
//                     {isSubmit ? (
//                       <l-waveform
//                         size="20"
//                         stroke="3.5"
//                         speed="1"
//                         color="black"
//                       ></l-waveform>
//                     ) : (
//                       <>
//                         <i className="fa-solid fa-check done-container"></i>
//                         {editVehicleData ? "Update" : "Save"}
//                       </>
//                     )}
//                   </button>
//                 )}
//               </div>
//             </div>
//           </Form>
//         )}
//       </Formik>
//     </div>
//   );
// };

// export default AddVehicleForm;